(function () {
  "use strict";

  var CONSENT_VERSION = "v1";
  var CONSENT_KEY = "basedai_privacy_consent";
  var GENERATION_ERROR_KEY = "basedai_generation_error";
  var HAIR_IQ_ATTRIBUTION_KEY = "hair_iq_attribution";
  var HAIR_IQ_ATTRIBUTION_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
  var PRIVATE_KEY_PREFIX = "basedai_";
  var PRIVATE_KEYS = [
    "basedai_jobId",
    "basedai_resultUrl",
    "basedai_userEmail",
    "basedai_label",
    "basedai_pending_label",
    "basedai_styleId",
    "basedai_styleLabel",
    "basedai_typeId",
    "basedai_typeLabel",
    "basedai_colorId",
    "basedai_colorLabel",
    "basedai_claimToken",
    "basedai_sessionToken",
    "basedai_sessionTokenExpiresAt",
    GENERATION_ERROR_KEY
  ];
  var MAX_PRIVATE_STORAGE_VALUE_CHARS = 512 * 1024;
  var DIAGNOSTICS_KEY = "__BasedAIPrivacyDiagnostics";
  var scriptEl = document.currentScript;
  var widgetAssetName = "find-your-hairstyle.js";
  var widgetAssetVersion = "hairiq-20260709-direct-photo";
  var turnstileSiteKey = scriptEl && scriptEl.getAttribute("data-turnstile-sitekey");
  var ga4MeasurementId = scriptEl && scriptEl.getAttribute("data-ga4-measurement-id");
  var ga4ForwardingDisabled = scriptEl && scriptEl.getAttribute("data-ga4-forwarding") === "off";
  var ga4DebugModeEnabled = scriptEl && scriptEl.getAttribute("data-ga4-debug-mode") === "true";
  var widgetLoaded = false;
  var turnstileScriptPromise = null;
  var turnstileWidgetId = null;
  var turnstileContainer = null;
  var TERMS_URL = "https://based.com/pages/terms-of-service";
  var PRIVACY_URL = "https://based.com/pages/privacy-policy";
  var MESSAGING_TERMS_URL = "https://terms.pscr.pt/legal/shop/basedbodyworks/terms_of_service";
  var MESSAGING_PRIVACY_URL = "https://terms.pscr.pt/legal/shop/basedbodyworks/privacy_policy";
  var RESULT_SHARE_FILE_NAME = "BASED-Hair-IQ-hairstyle.png";
  var RESULT_SHARE_TEXT = "Try Hair IQ for free: based.com/hairstyle";
  var LOADING_PHRASES = [
    "Mapping your hairline and temples",
    "Matching the cut to your head shape",
    "Blending texture into the original lighting",
    "Adding root depth and natural shadows",
    "Checking ears, sideburns, and neckline",
    "Breaking up perfect AI edges",
    "Tuning color with real lowlights",
    "Keeping your face and features untouched",
    "Softening flyaways into the photo grain",
    "Preparing the final reveal"
  ];
  var STYLE_PICKER_ASSETS = {
    "Mullet": "style-picker-ai__style-mullet.webp",
    "Buzz": "style-picker-ai__style-buzz.webp",
    "Fade": "style-picker-ai__style-fade.webp",
    "Middle Part": "style-picker-ai__style-middle-part.webp",
    "Side Part": "style-picker-ai__style-side-part.webp"
  };
  var loadingPhraseTimer = null;
  var loadingPhraseIndex = 0;
  var START_JOB_BUSY_MAX_WAIT_MS = 10 * 60 * 1000;
  var START_JOB_BUSY_BASE_DELAY_MS = 5000;
  var START_JOB_BUSY_MAX_DELAY_MS = 30000;
  var pendingCameraConsentResolvers = [];
  var activeSelfieCameraStreams = [];
  var observedSelfieCameraTracks = [];
  var selfieCameraVideoAttachmentTokens = new WeakMap();
  var selfieCameraVideoAttachmentSequence = 0;
  var cameraResumeListenersInstalled = false;
  var lastSelfieCameraRequest = null;
  var selfieCameraRequestSequence = 0;
  var selfieCameraRequestInFlightCount = 0;
  var selfieCameraWasSuspended = false;
  var selfieCameraResumeReacquireInFlight = false;
  var selfieCameraResumePending = false;
  var selfieCameraResumePendingSource = "";
  var selfieCameraResumeTimerIds = [];
  var selfieCameraResumeScheduleId = 0;
  var selfieCameraPlaybackRecoveryTimerId = null;
  var lastSelfieCameraResumeReacquireAt = 0;
  var selfieCameraResumeGeneration = 0;
  var selfieCameraNativeAcquisitionTail = Promise.resolve();
  var SELFIE_CAMERA_REACQUIRE_MIN_INTERVAL_MS = 2000;
  var SELFIE_CAMERA_RESUME_RESTART_DELAY_MS = 160;
  var SELFIE_CAMERA_RESUME_RESTART_MAX_ATTEMPTS = 3;
  var SELFIE_CAMERA_PLAYBACK_RECOVERY_DELAY_MS = 200;
  var SELFIE_CAMERA_PLAY_TIMEOUT_MS = 3500;
  var SELFIE_CAMERA_VIDEO_READY_TIMEOUT_MS = 3500;
  var SELFIE_CAMERA_CALLER_HANDOFF_TIMEOUT_MS = 10000;
  var HAIR_TYPE_SET_MAP = {
    straight: "textureEssentials",
    wavy: "beachyFlowDuo",
    curly: "volumeHoldDuo",
    coily: "volumeHoldDuo"
  };
  var HAIRSTYLE_SET_MATRIX = {
    buzz: {
      straight: "showerDuo",
      wavy: "showerDuo",
      curly: "showerDuo",
      coily: "showerDuo"
    },
    fade: {
      straight: "matteTextureDuo",
      wavy: "matteTextureDuo",
      curly: "volumeHoldDuo",
      coily: "volumeHoldDuo"
    },
    "middle-part": {
      straight: "beachyFlowDuo",
      wavy: "beachyFlowDuo",
      curly: "volumeHoldDuo",
      coily: "volumeHoldDuo"
    },
    "side-part": {
      straight: "beachyFlowDuo",
      wavy: "beachyFlowDuo",
      curly: "volumeHoldDuo",
      coily: "volumeHoldDuo"
    },
    mullet: {
      straight: "textureHoldDuo",
      wavy: "textureHoldDuo",
      curly: "volumeHoldDuo",
      coily: "volumeHoldDuo"
    }
  };
  var SET_RECOMMENDATIONS = {
    textureEssentials: {
      id: "texture-essentials",
      name: "Texture Essentials",
      url: "https://based.com/products/texture-essentials",
      image: "bundles__texture-essentials.webp",
      eyebrow: "Volume + texture",
      bestFor: "Straight to wavy hair, 0-6 inches",
      contains: "Texture Powder and Sea Salt Spray",
      line: "For flat hair that needs instant volume, separation, and a natural textured finish."
    },
    beachyFlowDuo: {
      id: "beachy-flow-duo",
      name: "Beachy Flow Duo",
      url: "https://based.com/products/beachy-flow-duo",
      image: "bundles__beachy-flow-duo.webp",
      eyebrow: "Flow + control",
      bestFor: "Straight to curly hair, 0-6 inches",
      contains: "Sea Salt Spray and Pomade",
      line: "For loose, parted, and wavy looks that need beachy texture with enough control to hold shape."
    },
    textureHoldDuo: {
      id: "texture-hold-duo",
      name: "Texture & Hold Duo",
      url: "https://based.com/products/texture-hold-duo",
      image: "bundles__texture-hold-duo.webp",
      eyebrow: "Texture + hold",
      bestFor: "Straight to wavy hair, 2-8+ inches",
      contains: "Sea Salt Spray and Hair Clay",
      line: "For textured cuts that need volume, shape, and flexible hold without a stiff finish."
    },
    matteTextureDuo: {
      id: "matte-texture-duo",
      name: "Matte Texture Duo",
      url: "https://based.com/products/matte-texture-duo",
      image: "bundles__matte-texture-duo.webp",
      eyebrow: "Matte texture",
      bestFor: "Straight to wavy hair, 0-6 inches",
      contains: "Texture Powder and Hair Clay",
      line: "For short or flat styles that need instant volume, matte texture, and controlled hold."
    },
    showerDuo: {
      id: "shower-duo",
      name: "Shower Duo",
      url: "https://based.com/products/shower-duo",
      image: "card-shower-duo.webp",
      eyebrow: "Hair + scalp care",
      bestFor: "All hair types and lengths",
      contains: "Shampoo and Conditioner",
      line: "For a cleaner, healthier-looking buzz cut and scalp without unnecessary styling product."
    },
    volumeHoldDuo: {
      id: "volume-hold-duo",
      name: "Volume & Hold Duo",
      url: "https://based.com/products/volume-hold-duo",
      image: "bundles__volume-hold-duo.webp",
      eyebrow: "Volume + hold",
      bestFor: "Wavy, curly, and coily hair, 2-4+ inches",
      contains: "Curl Mousse and Curl Gel",
      line: "For wavy, curly, and coily styles that need lasting volume, definition, and stronger hold."
    }
  };

  function nowIso() {
    return new Date().toISOString();
  }

  function recordDiagnostic(event, detail) {
    try {
      var list = window[DIAGNOSTICS_KEY] || [];
      list.push({ event: event, detail: detail || {}, at: nowIso() });
      window[DIAGNOSTICS_KEY] = list.slice(-30);
      if (window.console && typeof window.console.warn === "function") {
        window.console.warn("[BasedAIPrivacy]", event, detail || {});
      }
    } catch (_) {}
  }

  var funnelAnalyticsSeen = {};
  var ANALYTICS_PRIVATE_KEYS = {
    email: true,
    customeremail: true,
    customer_email: true,
    customerid: true,
    customer_id: true,
    imagedataurl: true,
    image_data_url: true,
    selfieurl: true,
    selfie_url: true,
    selfiedataurl: true,
    selfie_data_url: true,
    resulturl: true,
    result_url: true,
    imageurl: true,
    image_url: true,
    jobid: true,
    job_id: true,
    claimtoken: true,
    claim_token: true,
    sessiontoken: true,
    session_token: true
  };

  function analyticsCustomEventName(event) {
    return "basedai:" + String(event || "")
      .replace(/^basedai_/, "")
      .replace(/_/g, "-");
  }

  function analyticsSelectionContext(label) {
    var storedStyleId = readStorageValue("basedai_styleId");
    var storedTypeId = readStorageValue("basedai_typeId");
    var storedColorId = readStorageValue("basedai_colorId");
    var resultLabel = label || readPendingLabel() || readResultLabel();
    var inferredTypeId = storedTypeId || (resultLabel ? readSelectedTypeId(resultLabel) : "");
    return {
      result_label: resultLabel || null,
      hair_type: inferredTypeId || null,
      style_id: storedStyleId || null,
      style_label: readStorageValue("basedai_styleLabel") || null,
      type_id: storedTypeId || null,
      type_label: readStorageValue("basedai_typeLabel") || null,
      color_id: storedColorId || null,
      color_label: readStorageValue("basedai_colorLabel") || null
    };
  }

  function isPrivateAnalyticsValue(value) {
    if (typeof value !== "string") return false;
    return (
      /^data:image\//i.test(value) ||
      /(?:firebasestorage|storage\.googleapis|X-Goog-Signature|X-Goog-Credential)/i.test(value)
    );
  }

  function sanitizeAnalyticsPayload(payload) {
    var clean = Object.assign({}, payload || {});
    Object.keys(clean).forEach(function (key) {
      var normalizedKey = String(key || "").replace(/[^a-zA-Z0-9_]/g, "").toLowerCase();
      if (ANALYTICS_PRIVATE_KEYS[normalizedKey] || isPrivateAnalyticsValue(clean[key])) {
        delete clean[key];
      }
    });
    return clean;
  }

  function addPresentParam(target, key, value) {
    if (value === undefined || value === null || value === "") return;
    target[key] = value;
  }

  function buildGa4EventParams(payload) {
    var params = sanitizeAnalyticsPayload(Object.assign({}, payload || {}));
    delete params.event;

    addPresentParam(params, "hair_iq_result_label", params.result_label);
    addPresentParam(params, "hair_iq_style_id", params.style_id);
    addPresentParam(params, "hair_iq_type_id", params.type_id);
    addPresentParam(params, "hair_iq_color_id", params.color_id);
    addPresentParam(params, "hair_iq_set_id", params.set_id);

    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (
        key.indexOf("gtm.") === 0 ||
        value === undefined ||
        value === null ||
        (typeof value !== "string" && typeof value !== "number" && typeof value !== "boolean")
      ) {
        delete params[key];
      }
    });

    if (ga4MeasurementId) {
      params.send_to = ga4MeasurementId;
    }
    if (ga4DebugModeEnabled) {
      params.debug_mode = "1";
      params.engagement_time_msec = params.engagement_time_msec || 1;
    }

    return sanitizeAnalyticsPayload(params);
  }

  function forwardAnalyticsEventToGtag(event, payload) {
    try {
      if (ga4ForwardingDisabled || typeof window.gtag !== "function") return;
      window.gtag("event", event, buildGa4EventParams(payload));
    } catch (_) {}
  }

  function pushAnalyticsEvent(event, detail, options) {
    try {
      var onceKey = options && options.onceKey;
      if (onceKey && funnelAnalyticsSeen[onceKey]) return null;
      if (onceKey) funnelAnalyticsSeen[onceKey] = true;
      var rawDetail = detail || {};
      var payload = sanitizeAnalyticsPayload(Object.assign(
        {
          event: event,
          at: nowIso()
        },
        analyticsSelectionContext(rawDetail.result_label),
        rawDetail
      ));
      try {
        window.dispatchEvent(new CustomEvent(analyticsCustomEventName(event), { detail: payload }));
      } catch (_) {}
      forwardAnalyticsEventToGtag(event, Object.assign({}, payload));
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (_) {}
      return payload;
    } catch (_) {
      return null;
    }
  }

  function readConsent() {
    try {
      var raw = window.sessionStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      var consent = JSON.parse(raw);
      if (consent.version !== CONSENT_VERSION) return null;
      if (!consent.expiresAt || Date.parse(consent.expiresAt) <= Date.now()) return null;
      if (
        consent.age18Plus !== true ||
        consent.termsAccepted !== true ||
        consent.biometricProcessing !== true ||
        consent.aiProcessing !== true ||
        consent.privacyPolicyAccepted !== true
      ) {
        return null;
      }
      return consent;
    } catch (_) {
      return null;
    }
  }

  function buildConsent(source) {
    var acceptedAt = nowIso();
    return {
      version: CONSENT_VERSION,
      acceptedAt: acceptedAt,
      expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
      source: source || "photo_action",
      age18Plus: true,
      termsAccepted: true,
      biometricProcessing: true,
      aiProcessing: true,
      privacyPolicyAccepted: true,
      marketingConsent: false,
      resultRetentionHours: 24
    };
  }

  function writeConsent(consent) {
    window.sessionStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    return consent;
  }

  function grantPhotoConsent(source) {
    var consent = readConsent() || writeConsent(buildConsent(source));
    pushAnalyticsEvent("basedai_photo_consent", {
      consent_source: consent.source || source || "photo_action"
    }, {
      onceKey: "photo_consent"
    });
    flushPendingCameraConsent();
    return consent;
  }

  function grantEmailConsent() {
    var consent = readConsent() || buildConsent("email_action");
    consent.marketingConsent = true;
    consent.emailAcceptedAt = nowIso();
    consent = writeConsent(consent);
    pushAnalyticsEvent("basedai_email_consent", {
      marketing_consent: true
    }, {
      onceKey: "email_consent"
    });
    return consent;
  }

  function clearConsent() {
    try {
      window.sessionStorage.removeItem(CONSENT_KEY);
    } catch (_) {}
  }

  function waitForPhotoConsent() {
    if (readConsent()) return Promise.resolve();
    return new Promise(function (resolve) {
      pendingCameraConsentResolvers.push(resolve);
      recordDiagnostic("camera_waiting_for_photo_consent", {
        pending: pendingCameraConsentResolvers.length
      });
    });
  }

  function flushPendingCameraConsent() {
    if (!readConsent() || !pendingCameraConsentResolvers.length) return;
    var resolvers = pendingCameraConsentResolvers.splice(0);
    resolvers.forEach(function (resolve) {
      try {
        resolve();
      } catch (_) {}
    });
  }

  function findPhotoConsentCheckbox(root) {
    var scope = root || document;
    return scope.querySelector ? scope.querySelector(".basedai-photo-consent-checkbox") : null;
  }

  function setPhotoConsentError(message) {
    var error = document.querySelector(".basedai-photo-consent-error");
    if (!error) return;
    error.textContent = message || "";
    error.hidden = !message;
  }

  function keepCameraRetryAvailable(widget, accepted) {
    if (!accepted || !/Camera unavailable/i.test(normalizeText(widget))) return;
    Array.prototype.slice.call(widget.querySelectorAll("button")).forEach(function (button) {
      if (!isWidgetAction(button, /^TAKE SELFIE$/i)) return;
      if (!button.disabled || button.dataset.basedaiPrivacyDisabled === "true") return;
      button.disabled = false;
      button.removeAttribute("aria-disabled");
    });
  }

  function findPhotoActionShell(button) {
    if (!button || !button.closest) return null;
    return (
      button.closest(".basedai-widget") ||
      button.closest("[class*='flex']") ||
      document.querySelector(".basedai-widget")
    );
  }

  function findPhotoFileInput(button) {
    var widget = button && button.closest ? button.closest(".basedai-widget") : document.querySelector(".basedai-widget");
    if (!widget || !widget.querySelectorAll) return null;
    var inputs = Array.prototype.slice.call(widget.querySelectorAll("input[type='file']"));
    return inputs.find(function (input) {
      return /image\//i.test(input.getAttribute("accept") || "");
    }) || null;
  }

  function hasReadySelfieVideo(button) {
    var shell = findPhotoActionShell(button);
    var video = shell && shell.querySelector ? shell.querySelector("video") : null;
    return Boolean(video && video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0);
  }

  function shouldUseNativeSelfieFallback(button) {
    if (!isWidgetAction(button, /^TAKE SELFIE$/i)) return false;
    if (!readConsent()) return false;
    if (!findPhotoFileInput(button)) return false;
    var widget = button.closest(".basedai-widget");
    var text = normalizeText(widget);
    return /Camera unavailable|Camera not supported|Take Selfie.? to (?:enable|start) the camera|consent box/i.test(text) || !hasReadySelfieVideo(button);
  }

  function triggerNativeSelfieFallback(button) {
    var input = findPhotoFileInput(button);
    if (!input || typeof input.click !== "function") return false;
    var previousCapture = input.getAttribute("capture");
    input.setAttribute("capture", "user");
    recordDiagnostic("camera_native_selfie_fallback_opened", {});
    try {
      input.click();
    } finally {
      window.setTimeout(function () {
        if (previousCapture === null) {
          input.removeAttribute("capture");
        } else {
          input.setAttribute("capture", previousCapture);
        }
      }, 1000);
    }
    return true;
  }

  function syncPhotoConsentState(root) {
    var widget = root || document.querySelector(".basedai-widget");
    if (!widget) return;
    var checkbox = findPhotoConsentCheckbox(widget);
    var hasConsent = Boolean(readConsent());
    if (!hasConsent && checkbox && checkbox.checked) {
      grantPhotoConsent("photo_clickwrap");
      hasConsent = true;
    }
    var accepted = hasConsent || Boolean(checkbox && checkbox.checked);
    if (checkbox && hasConsent && !checkbox.checked) {
      checkbox.checked = true;
    }
    Array.prototype.slice.call(widget.querySelectorAll("button")).forEach(function (button) {
      if (!isWidgetAction(button, /^(TAKE SELFIE|UPLOAD SELFIE(?:\s*→)?|UPLOAD FROM LIBRARY|CONTINUE)$/i)) return;
      if (!accepted) {
        if (button.dataset.basedaiPrivacyDisabled !== "true") {
          button.dataset.basedaiPrivacyWasDisabled = button.disabled ? "true" : "false";
        }
        button.dataset.basedaiPrivacyDisabled = "true";
        button.disabled = false;
        button.setAttribute("aria-disabled", "true");
        button.classList.add("basedai-photo-action-disabled");
      } else {
        button.disabled = false;
        delete button.dataset.basedaiPrivacyDisabled;
        delete button.dataset.basedaiPrivacyWasDisabled;
        button.removeAttribute("aria-disabled");
        button.classList.remove("basedai-photo-action-disabled");
      }
    });
    keepCameraRetryAvailable(widget, accepted);
  }

  function requirePhotoConsentClickwrap(event) {
    var checkbox = findPhotoConsentCheckbox();
    if (readConsent() || (checkbox && checkbox.checked)) {
      var widget = document.querySelector(".basedai-widget");
      if (!widget || widget.getAttribute("data-basedai-camera-recovery") !== "failed") {
        setPhotoConsentError("");
      }
      grantPhotoConsent("photo_clickwrap");
      syncPhotoConsentState();
      return true;
    }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    }
    setPhotoConsentError("Please accept the photo terms before taking or uploading a selfie.");
    if (checkbox && typeof checkbox.focus === "function") {
      try {
        checkbox.focus({ preventScroll: true });
      } catch (_) {
        checkbox.focus();
      }
    }
    return false;
  }

  function applyPhotoConsentCheckboxState(checkbox) {
    if (!checkbox) return;
    if (checkbox.checked) {
      grantPhotoConsent("photo_clickwrap");
      setPhotoConsentError("");
    } else {
      clearConsent();
    }
    syncPhotoConsentState();
  }

  function isObject(value) {
    return value !== null && typeof value === "object";
  }

  function normalizeSelfieCameraConstraints(constraints) {
    var next = isObject(constraints) ? Object.assign({}, constraints) : {};
    var video = next.video;
    if (video === false) return constraints;
    if (video === true || !isObject(video)) {
      video = {};
    } else {
      video = Object.assign({}, video);
    }

    var facingMode = video.facingMode;
    var requestsUserCamera =
      !facingMode ||
      facingMode === "user" ||
      (isObject(facingMode) && (facingMode.ideal === "user" || facingMode.exact === "user"));

    if (requestsUserCamera) {
      if (!facingMode || facingMode === "user" || (isObject(facingMode) && facingMode.exact === "user")) {
        video.facingMode = { ideal: "user" };
      }
      if (!video.width) video.width = { ideal: 1280 };
      if (!video.height) video.height = { ideal: 1706 };
      if (!video.aspectRatio) video.aspectRatio = { ideal: 0.75 };
    }

    next.video = video;
    return next;
  }

  function cameraErrorSummary(error) {
    return {
      name: error && error.name ? error.name : "",
      message: error && error.message ? error.message : String(error || "")
    };
  }

  function shouldRetrySelfieCamera(error) {
    if (error && error.basedaiCameraResumeCanceled) return false;
    var name = error && error.name ? error.name : "";
    return (
      name === "NotReadableError" ||
      name === "AbortError" ||
      name === "OverconstrainedError" ||
      name === "ConstraintNotSatisfiedError" ||
      name === "TypeError"
    );
  }

  function selfieCameraCancellationError(message) {
    var error = new Error(message || "Camera request canceled.");
    error.name = "AbortError";
    error.basedaiCameraResumeCanceled = true;
    return error;
  }

  function isSelfieCameraPageVisible() {
    return !document.hidden && (!document.visibilityState || document.visibilityState === "visible");
  }

  function waitForSelfieCameraPageVisible(cameraRequest) {
    if (cameraRequest !== lastSelfieCameraRequest) {
      return Promise.reject(
        selfieCameraCancellationError("Camera request canceled because a newer request is active.")
      );
    }
    if (isSelfieCameraPageVisible()) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var settled = false;

      function cleanup() {
        document.removeEventListener("visibilitychange", checkVisibility);
        window.removeEventListener("pageshow", checkVisibility);
        window.removeEventListener("focus", checkVisibility);
        if (cameraRequest.cancelVisibilityWait === cancelVisibilityWait) {
          delete cameraRequest.cancelVisibilityWait;
        }
      }

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        cleanup();
        callback(value);
      }

      function cancelVisibilityWait() {
        settle(
          reject,
          selfieCameraCancellationError("Camera request canceled because a newer request is active.")
        );
      }

      function checkVisibility() {
        if (cameraRequest !== lastSelfieCameraRequest) {
          cancelVisibilityWait();
          return;
        }
        if (isSelfieCameraPageVisible()) settle(resolve);
      }

      cameraRequest.cancelVisibilityWait = cancelVisibilityWait;
      document.addEventListener("visibilitychange", checkVisibility);
      window.addEventListener("pageshow", checkVisibility);
      window.addEventListener("focus", checkVisibility);
      checkVisibility();
    });
  }

  function runSerializedSelfieCameraAcquisition(task) {
    var acquisition = selfieCameraNativeAcquisitionTail.then(task, task);
    selfieCameraNativeAcquisitionTail = acquisition.then(
      function () {},
      function () {}
    );
    return acquisition;
  }

  function selfieCameraConstraintAttempts(constraints) {
    var preferred = normalizeSelfieCameraConstraints(constraints);
    var attempts = [{ label: "preferred_selfie", constraints: preferred }];
    if (preferred && preferred.video === false) return attempts;

    attempts.push({
      label: "user_facing_no_dimensions",
      constraints: {
        audio: false,
        video: { facingMode: { ideal: "user" } }
      }
    });
    attempts.push({
      label: "browser_default_video",
      constraints: {
        audio: false,
        video: true
      }
    });
    return attempts;
  }

  function pickCameraSettings(settings) {
    if (!settings) return {};
    return {
      deviceId: settings.deviceId ? "present" : "",
      facingMode: settings.facingMode || "",
      width: settings.width || "",
      height: settings.height || "",
      aspectRatio: settings.aspectRatio || "",
      frameRate: settings.frameRate || "",
      zoom: settings.zoom || ""
    };
  }

  function pickCameraCapabilities(capabilities) {
    if (!capabilities) return {};
    return {
      facingMode: capabilities.facingMode || "",
      width: capabilities.width || "",
      height: capabilities.height || "",
      aspectRatio: capabilities.aspectRatio || "",
      frameRate: capabilities.frameRate || "",
      zoom: capabilities.zoom || ""
    };
  }

  function pruneSelfieCameraStreams() {
    activeSelfieCameraStreams = activeSelfieCameraStreams.filter(function (stream) {
      try {
        if (!stream || typeof stream.getVideoTracks !== "function") return false;
        return stream.getVideoTracks().some(function (track) {
          return track && track.readyState !== "ended";
        });
      } catch (_) {
        return false;
      }
    });
  }

  function trackSelfieCameraStream(stream) {
    if (!stream) return;
    if (activeSelfieCameraStreams.indexOf(stream) === -1) {
      activeSelfieCameraStreams.push(stream);
    }
    try {
      stream.getVideoTracks().forEach(function (track) {
        if (
          track &&
          typeof track.addEventListener === "function" &&
          observedSelfieCameraTracks.indexOf(track) === -1
        ) {
          observedSelfieCameraTracks.push(track);
          track.addEventListener("ended", function () {
            var wasAttached = findSelfieCameraVideos().some(function (video) {
              return video && video.srcObject === stream;
            });
            forgetObservedSelfieCameraTrack(track);
            pruneSelfieCameraStreams();
            if (
              wasAttached &&
              isSelfieCameraPageVisible() &&
              lastSelfieCameraRequest
            ) {
              selfieCameraWasSuspended = true;
              scheduleSelfieCameraResumeRetune("track-ended");
            }
          });
        }
      });
    } catch (_) {}
    installSelfieCameraResumeRetune();
  }

  function isVisibleSelfieCameraVideo(video) {
    if (!video || !video.isConnected) return false;
    try {
      var rect = video.getBoundingClientRect();
      return rect && rect.width > 40 && rect.height > 40;
    } catch (_) {
      return false;
    }
  }

  function findSelfieCameraVideos() {
    try {
      return Array.prototype.slice.call(document.querySelectorAll("#based-hair-iq-page video, .basedai-widget video")).filter(function (video) {
        return video && video.isConnected;
      });
    } catch (_) {
      return [];
    }
  }

  function findVisibleSelfieCameraVideos() {
    return findSelfieCameraVideos().filter(function (video) {
      return isVisibleSelfieCameraVideo(video);
    });
  }

  function findAttachedSelfieCameraVideos() {
    return findSelfieCameraVideos().filter(function (video) {
      return !!video.srcObject;
    });
  }

  function findActiveSelfieCameraVideos() {
    return findVisibleSelfieCameraVideos().filter(function (video) {
      return !!video.srcObject;
    });
  }

  function findSelfieCameraOwnerVideo() {
    return findVisibleSelfieCameraVideos()[0] || findSelfieCameraVideos()[0] || null;
  }

  function findSelfieCameraOwnerWidget(video) {
    if (video && video.closest) {
      return video.closest(".basedai-widget") || video.closest("#based-hair-iq-page");
    }
    return document.querySelector(".basedai-widget") || document.querySelector("#based-hair-iq-page");
  }

  function refreshSelfieCameraRequestOwner(cameraRequest, preferredVideo) {
    if (!cameraRequest) return null;
    var candidate = preferredVideo && preferredVideo.isConnected ? preferredVideo : null;
    if (!candidate && cameraRequest.ownerVideo && cameraRequest.ownerVideo.isConnected) {
      candidate = cameraRequest.ownerVideo;
    }
    if (!candidate) {
      var videos = findVisibleSelfieCameraVideos();
      candidate = videos.find(function (video) {
        return !cameraRequest.ownerWidget ||
          (video.closest && video.closest(".basedai-widget, #based-hair-iq-page") === cameraRequest.ownerWidget);
      }) || null;
    }
    if (candidate) {
      cameraRequest.ownerVideo = candidate;
      cameraRequest.ownerWidget = findSelfieCameraOwnerWidget(candidate) || cameraRequest.ownerWidget;
    }
    return candidate;
  }

  function selfieCameraRequestOwnerIsAvailable(cameraRequest) {
    if (!cameraRequest) return false;
    if (cameraRequest.ownerWidget && !cameraRequest.ownerWidget.isConnected) return false;
    if (!cameraRequest.ownerVideoRequired) return true;
    return !!refreshSelfieCameraRequestOwner(cameraRequest);
  }

  function isSelfieCameraStreamInUse(stream) {
    return findSelfieCameraVideos().some(function (video) {
      return video && video.srcObject === stream;
    });
  }

  function forgetObservedSelfieCameraTrack(track) {
    observedSelfieCameraTracks = observedSelfieCameraTracks.filter(function (observedTrack) {
      return observedTrack !== track;
    });
  }

  function stopSelfieCameraStream(stream) {
    try {
      if (!stream || typeof stream.getTracks !== "function") return;
      stream.getTracks().forEach(function (track) {
        forgetObservedSelfieCameraTrack(track);
        if (track && typeof track.stop === "function" && track.readyState !== "ended") {
          track.stop();
        }
      });
    } catch (_) {}
    pruneSelfieCameraStreams();
  }

  function stopSelfieCameraStreamWhenDetached(video, stream, attachmentToken) {
    try {
      if (!video || !video.isConnected || video.srcObject !== stream) {
        if (!isSelfieCameraStreamInUse(stream)) stopSelfieCameraStream(stream);
        return;
      }
      var timer = window.setInterval(function () {
        var hasLiveTrack = false;
        try {
          hasLiveTrack = stream && stream.getVideoTracks().some(function (track) {
            return track && track.readyState !== "ended";
          });
        } catch (_) {}
        if (!hasLiveTrack) {
          window.clearInterval(timer);
          stopSelfieCameraStream(stream);
          return;
        }
        if (
          attachmentToken &&
          selfieCameraVideoAttachmentTokens.get(video) !== attachmentToken
        ) {
          window.clearInterval(timer);
          if (!isSelfieCameraStreamInUse(stream)) stopSelfieCameraStream(stream);
          return;
        }
        if (!video.isConnected || video.srcObject !== stream) {
          window.clearInterval(timer);
          if (!isSelfieCameraStreamInUse(stream)) stopSelfieCameraStream(stream);
        }
      }, 250);
    } catch (_) {}
  }

  function stopSelfieCameraStreamUnlessAttached(stream, cameraRequest) {
    var settled = false;
    var intervalId = null;
    var timeoutId = null;

    function cleanup() {
      if (settled) return;
      settled = true;
      if (intervalId) window.clearInterval(intervalId);
      if (timeoutId) window.clearTimeout(timeoutId);
    }

    function stopIfUnused() {
      cleanup();
      if (!isSelfieCameraStreamInUse(stream)) stopSelfieCameraStream(stream);
    }

    function watchCurrentAttachments() {
      var attachedVideos = findSelfieCameraVideos().filter(function (video) {
        return video && video.srcObject === stream;
      });
      if (!attachedVideos.length) return false;
      attachedVideos.forEach(function (video) {
        stopSelfieCameraStreamWhenDetached(
          video,
          stream,
          selfieCameraVideoAttachmentTokens.get(video)
        );
      });
      cleanup();
      return true;
    }

    function check() {
      if (watchCurrentAttachments()) {
        cleanup();
        return;
      }
      if (
        cameraRequest !== lastSelfieCameraRequest ||
        (cameraRequest.ownerWidget && !cameraRequest.ownerWidget.isConnected)
      ) {
        stopIfUnused();
      }
    }

    intervalId = window.setInterval(check, 250);
    timeoutId = window.setTimeout(function () {
      if (settled) return;
      if (watchCurrentAttachments()) return;
      recordDiagnostic("camera_initial_handoff_abandoned", {
        requestId: cameraRequest.id || 0
      });
      stopIfUnused();
    }, SELFIE_CAMERA_CALLER_HANDOFF_TIMEOUT_MS);
    check();
  }

  function selfieCameraVideoIsReady(video, stream) {
    return Boolean(
      video &&
      video.isConnected &&
      video.srcObject === stream &&
      video.readyState >= 2 &&
      video.videoWidth > 0 &&
      video.videoHeight > 0
    );
  }

  function waitForSelfieCameraVideoReady(
    video,
    stream,
    attachmentToken,
    source,
    attachmentOptions,
    expectedTrack
  ) {
    if (
      !selfieCameraAttachmentIsCurrent(
        video,
        stream,
        attachmentToken,
        attachmentOptions,
        expectedTrack
      )
    ) {
      return Promise.reject(
        selfieCameraCancellationError(
          "Camera preview was superseded before it became ready."
        )
      );
    }
    if (selfieCameraVideoIsReady(video, stream)) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (
          !selfieCameraAttachmentIsCurrent(
            video,
            stream,
            attachmentToken,
            attachmentOptions,
            expectedTrack
          )
        ) {
          settle(
            reject,
            selfieCameraCancellationError(
              "Camera preview was superseded before it became ready."
            )
          );
          return;
        }
        settle(
          reject,
          new Error("Camera preview did not become ready after resume.")
        );
      }, SELFIE_CAMERA_VIDEO_READY_TIMEOUT_MS);

      function cleanup() {
        window.clearTimeout(timeout);
        ["loadeddata", "canplay", "playing", "error"].forEach(function (eventName) {
          video.removeEventListener(eventName, check);
        });
      }

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        cleanup();
        callback(value);
      }

      function check(event) {
        if (
          !selfieCameraAttachmentIsCurrent(
            video,
            stream,
            attachmentToken,
            attachmentOptions,
            expectedTrack
          )
        ) {
          settle(
            reject,
            selfieCameraCancellationError(
              "Camera preview was superseded during resume."
            )
          );
          return;
        }
        if (event && event.type === "error") {
          settle(reject, new Error("Camera preview failed during resume."));
          return;
        }
        if (selfieCameraVideoIsReady(video, stream)) settle(resolve);
      }

      ["loadeddata", "canplay", "playing", "error"].forEach(function (eventName) {
        video.addEventListener(eventName, check);
      });
      recordDiagnostic("camera_video_resume_waiting", {
        source: source || "unknown"
      });
      check();
    });
  }

  function selfieCameraAttachmentRequestIsCurrent(options) {
    if (!options) return true;
    if (
      typeof options.requestGeneration === "number" &&
      options.requestGeneration !== selfieCameraResumeGeneration
    ) {
      return false;
    }
    if (options.cameraRequest && options.cameraRequest !== lastSelfieCameraRequest) {
      return false;
    }
    return options.requireVisible === false || isSelfieCameraPageVisible();
  }

  function selfieCameraAttachmentIsCurrent(
    video,
    stream,
    attachmentToken,
    attachmentOptions,
    expectedTrack
  ) {
    if (
      !video ||
      !video.isConnected ||
      video.srcObject !== stream ||
      selfieCameraVideoAttachmentTokens.get(video) !== attachmentToken ||
      !selfieCameraAttachmentRequestIsCurrent(attachmentOptions)
    ) {
      return false;
    }
    if (!expectedTrack) return true;
    try {
      return (
        expectedTrack.readyState !== "ended" &&
        stream.getVideoTracks().indexOf(expectedTrack) !== -1
      );
    } catch (_) {
      return false;
    }
  }

  function waitForSelfieCameraPlayback(
    video,
    playPromise,
    stream,
    attachmentToken,
    source,
    attachmentOptions,
    expectedTrack
  ) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeoutId = window.setTimeout(function () {
        if (
          !selfieCameraAttachmentIsCurrent(
            video,
            stream,
            attachmentToken,
            attachmentOptions,
            expectedTrack
          )
        ) {
          settle(
            reject,
            selfieCameraCancellationError(
              "Camera playback was superseded before it became ready."
            )
          );
          return;
        }
        settle(reject, new Error("Camera playback did not start after resume."));
      }, SELFIE_CAMERA_PLAY_TIMEOUT_MS);

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        callback(value);
      }

      Promise.resolve(playPromise).then(
        function () {
          if (
            !selfieCameraAttachmentIsCurrent(
              video,
              stream,
              attachmentToken,
              attachmentOptions,
              expectedTrack
            )
          ) {
            settle(
              reject,
              selfieCameraCancellationError(
                "Camera playback was superseded before it started."
              )
            );
            return;
          }
          settle(resolve);
        },
        function (error) {
          if (
            !selfieCameraAttachmentIsCurrent(
              video,
              stream,
              attachmentToken,
              attachmentOptions,
              expectedTrack
            )
          ) {
            settle(
              reject,
              selfieCameraCancellationError(
                "Camera playback was canceled by a lifecycle change."
              )
            );
            return;
          }
          settle(reject, error);
        }
      );

      recordDiagnostic("camera_video_play_waiting", {
        source: source || "unknown"
      });
    });
  }

  function detachOwnedSelfieCameraStreamFromVideos(
    videos,
    stream,
    attachmentToken,
    source
  ) {
    videos.forEach(function (video) {
      if (selfieCameraVideoAttachmentTokens.get(video) !== attachmentToken) return;
      try {
        if (video.srcObject !== stream) return;
        if (typeof video.pause === "function") video.pause();
        video.srcObject = null;
        video.removeAttribute("src");
        video.style.objectFit = "cover";
        video.style.objectPosition = "50% 50%";
        if (typeof video.load === "function") video.load();
      } catch (error) {
        recordDiagnostic("camera_video_detach_failed", {
          source: source || "unknown",
          message: error && error.message ? error.message : String(error)
        });
      } finally {
        if (selfieCameraVideoAttachmentTokens.get(video) === attachmentToken) {
          selfieCameraVideoAttachmentTokens.delete(video);
        }
      }
    });
    if (!isSelfieCameraStreamInUse(stream)) stopSelfieCameraStream(stream);
  }

  function attachSelfieCameraStreamToVideos(videos, stream, source, options) {
    var attachmentOptions = options || {};
    var attachmentToken = ++selfieCameraVideoAttachmentSequence;
    var activeVideos = videos.filter(function (video) {
      return attachmentOptions.allowHiddenVideos
        ? Boolean(video && video.isConnected)
        : isVisibleSelfieCameraVideo(video);
    });
    if (!activeVideos.length) {
      stopSelfieCameraStream(stream);
      return Promise.reject(
        selfieCameraCancellationError("Camera resume canceled because its preview was removed.")
      );
    }

    var readiness = activeVideos.map(function (video) {
      return Promise.resolve().then(function () {
        if (!selfieCameraAttachmentRequestIsCurrent(attachmentOptions)) {
          throw selfieCameraCancellationError(
            "Camera attachment canceled because the page or active request changed."
          );
        }
        selfieCameraVideoAttachmentTokens.set(video, attachmentToken);
        video.srcObject = stream;
        video.style.objectFit = "cover";
        video.style.objectPosition = "50% 50%";
        if (
          selfieCameraVideoAttachmentTokens.get(video) !== attachmentToken ||
          video.srcObject !== stream ||
          !selfieCameraAttachmentRequestIsCurrent(attachmentOptions)
        ) {
          throw selfieCameraCancellationError(
            "Camera attachment was superseded before playback began."
          );
        }

        var playPromise;
        try {
          playPromise = typeof video.play === "function" ? video.play() : Promise.resolve();
        } catch (error) {
          playPromise = Promise.reject(error);
        }
        if (attachmentOptions.requireReady === false) {
          Promise.resolve(playPromise).catch(function (error) {
            recordDiagnostic("camera_initial_handoff_play_deferred", {
              source: source || "initial",
              message: error && error.message ? error.message : String(error)
            });
          });
          return;
        }
        var expectedTrack = null;
        try {
          expectedTrack = stream.getVideoTracks()[0] || null;
        } catch (_) {}
        return waitForSelfieCameraPlayback(
          video,
          playPromise,
          stream,
          attachmentToken,
          source,
          attachmentOptions,
          expectedTrack
        )
          .then(function () {
            return waitForSelfieCameraVideoReady(
              video,
              stream,
              attachmentToken,
              source,
              attachmentOptions,
              expectedTrack
            );
          })
          .then(function () {
            if (
              selfieCameraVideoAttachmentTokens.get(video) !== attachmentToken ||
              video.srcObject !== stream ||
              !selfieCameraAttachmentRequestIsCurrent(attachmentOptions)
            ) {
              throw selfieCameraCancellationError(
                "Camera attachment was superseded before it became ready."
              );
            }
          });
      });
    });

    return Promise.all(readiness)
      .then(function () {
        activeVideos.forEach(function (video) {
          stopSelfieCameraStreamWhenDetached(video, stream, attachmentToken);
        });
        return activeVideos;
      })
      .catch(function (error) {
        detachOwnedSelfieCameraStreamFromVideos(
          activeVideos,
          stream,
          attachmentToken,
          (source || "resume") + ":attachment-failed"
        );
        throw error;
      });
  }

  function applyNeutralSelfieCameraZoom(track, source) {
    try {
      if (!track || typeof track.applyConstraints !== "function") return;
      var settings = typeof track.getSettings === "function" ? track.getSettings() : {};
      var capabilities = typeof track.getCapabilities === "function" ? track.getCapabilities() : {};
      var zoom = capabilities && capabilities.zoom;
      if (!zoom || typeof zoom.min !== "number" || typeof zoom.max !== "number") return;
      var targetZoom = zoom.min <= 1 && zoom.max >= 1 ? 1 : zoom.min;
      if (typeof settings.zoom === "number" && Math.abs(settings.zoom - targetZoom) < 0.001 && source === "initial") return;
      track
        .applyConstraints({ advanced: [{ zoom: targetZoom }] })
        .then(function () {
          recordDiagnostic("camera_zoom_neutral_applied", {
            source: source || "unknown",
            targetZoom: targetZoom,
            settings: pickCameraSettings(typeof track.getSettings === "function" ? track.getSettings() : {})
          });
        })
        .catch(function (error) {
          recordDiagnostic("camera_zoom_neutral_failed", {
            source: source || "unknown",
            targetZoom: targetZoom,
            message: error && error.message ? error.message : String(error)
          });
        });
    } catch (error) {
      recordDiagnostic("camera_zoom_neutral_error", {
        source: source || "unknown",
        message: error && error.message ? error.message : String(error)
      });
    }
  }

  function resumeSelfieCameraVideos(source) {
    try {
      findActiveSelfieCameraVideos().forEach(function (video) {
        var stream = video.srcObject;
        var attachmentToken = selfieCameraVideoAttachmentTokens.get(video);
        var resumeGeneration = selfieCameraResumeGeneration;
        var cameraRequest = lastSelfieCameraRequest;
        var expectedTrack = null;
        try {
          expectedTrack = stream && stream.getVideoTracks
            ? stream.getVideoTracks()[0] || null
            : null;
        } catch (_) {}
        video.style.objectFit = "cover";
        video.style.objectPosition = "50% 50%";
        if (typeof video.play === "function") {
          var playPromise;
          try {
            playPromise = video.play();
          } catch (error) {
            playPromise = Promise.reject(error);
          }
          waitForSelfieCameraPlayback(
            video,
            playPromise,
            stream,
            attachmentToken,
            source,
            {
              cameraRequest: cameraRequest,
              requestGeneration: resumeGeneration
            },
            expectedTrack
          ).catch(function (error) {
            if (error && error.basedaiCameraResumeCanceled) {
              recordDiagnostic("camera_video_resume_canceled", {
                source: source || "unknown"
              });
              return;
            }
            recordDiagnostic("camera_video_resume_failed", {
              source: source || "unknown",
              message: error && error.message ? error.message : String(error)
            });
            selfieCameraWasSuspended = true;
            scheduleSelfieCameraPlaybackRecovery((source || "resume") + ":play-failed");
          });
        }
      });
    } catch (_) {}
  }

  function scheduleSelfieCameraPlaybackRecovery(source) {
    if (
      selfieCameraPlaybackRecoveryTimerId ||
      selfieCameraResumeReacquireInFlight ||
      selfieCameraRequestInFlightCount > 0
    ) {
      return;
    }
    selfieCameraPlaybackRecoveryTimerId = window.setTimeout(function () {
      selfieCameraPlaybackRecoveryTimerId = null;
      if (!isSelfieCameraPageVisible() || !selfieCameraWasSuspended) return;
      reacquireSelfieCameraVideos(source || "playback-failed", { force: true });
    }, SELFIE_CAMERA_PLAYBACK_RECOVERY_DELAY_MS);
  }

  function requestResumeSelfieCameraStream(cameraRequest, source, attempt) {
    var requestAttempt = attempt || 0;
    var delayMs = SELFIE_CAMERA_RESUME_RESTART_DELAY_MS * (requestAttempt + 1);
    return wait(delayMs)
      .then(function () {
        if (!isSelfieCameraPageVisible() || cameraRequest !== lastSelfieCameraRequest) {
          throw selfieCameraCancellationError("Camera resume canceled because the request is no longer current.");
        }
        return requestSelfieCamera(cameraRequest.nativeGetUserMedia, cameraRequest.constraints, {
          cameraRequest: cameraRequest,
          source: source || "resume"
        });
      })
      .catch(function (error) {
        var canRetry = !error.basedaiCameraResumeCanceled &&
          isSelfieCameraPageVisible() &&
          cameraRequest === lastSelfieCameraRequest &&
          shouldRetrySelfieCamera(error) &&
          requestAttempt + 1 < SELFIE_CAMERA_RESUME_RESTART_MAX_ATTEMPTS;
        if (canRetry) {
          recordDiagnostic("camera_resume_reacquire_retry", {
            source: source || "unknown",
            attempt: requestAttempt + 1,
            message: error && error.message ? error.message : String(error)
          });
          return requestResumeSelfieCameraStream(cameraRequest, source, requestAttempt + 1);
        }
        throw error;
      });
  }

  function detachSelfieCameraVideos(videos, source) {
    var oldStreams = [];
    videos.forEach(function (video) {
      if (video.srcObject && oldStreams.indexOf(video.srcObject) === -1) oldStreams.push(video.srcObject);
    });

    videos.forEach(function (video) {
      try {
        if (typeof video.pause === "function") video.pause();
        video.srcObject = null;
        selfieCameraVideoAttachmentTokens.delete(video);
        video.removeAttribute("src");
        video.style.objectFit = "cover";
        video.style.objectPosition = "50% 50%";
        if (typeof video.load === "function") video.load();
      } catch (error) {
        recordDiagnostic("camera_video_detach_failed", {
          source: source || "unknown",
          message: error && error.message ? error.message : String(error)
        });
      }
    });

    oldStreams.forEach(function (oldStream) {
      stopSelfieCameraStream(oldStream);
    });

    return oldStreams.length;
  }

  function invalidateSelfieCameraResume() {
    selfieCameraResumeGeneration += 1;
    selfieCameraResumeScheduleId += 1;
    selfieCameraResumeTimerIds.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    selfieCameraResumeTimerIds = [];
    if (selfieCameraPlaybackRecoveryTimerId) {
      window.clearTimeout(selfieCameraPlaybackRecoveryTimerId);
      selfieCameraPlaybackRecoveryTimerId = null;
    }
    selfieCameraResumePending = false;
    selfieCameraResumePendingSource = "";
  }

  function scheduleSelfieCameraResumeTimer(callback, delay) {
    var timerId = window.setTimeout(function () {
      selfieCameraResumeTimerIds = selfieCameraResumeTimerIds.filter(function (activeTimerId) {
        return activeTimerId !== timerId;
      });
      callback();
    }, delay);
    selfieCameraResumeTimerIds.push(timerId);
  }

  function stopTrackedSelfieCameraStreams() {
    var streams = activeSelfieCameraStreams.slice();
    streams.forEach(function (stream) {
      stopSelfieCameraStream(stream);
    });
    pruneSelfieCameraStreams();
    return streams.length;
  }

  function suspendSelfieCameraVideos(source) {
    invalidateSelfieCameraResume();
    if (!lastSelfieCameraRequest) return;
    var videos = findAttachedSelfieCameraVideos();
    var trackedStreams = activeSelfieCameraStreams.length;
    var hadPendingRequest = selfieCameraRequestInFlightCount > 0 || selfieCameraResumeReacquireInFlight;
    var detachedStreams = videos.length ? detachSelfieCameraVideos(videos, source || "suspend") : 0;
    var stoppedStreams = stopTrackedSelfieCameraStreams();
    if (!videos.length && !trackedStreams && !hadPendingRequest && !selfieCameraWasSuspended) return;
    selfieCameraWasSuspended = true;
    lastSelfieCameraResumeReacquireAt = 0;
    recordDiagnostic("camera_suspend_completed", {
      source: source || "unknown",
      videos: videos.length,
      detachedStreams: detachedStreams,
      stoppedStreams: stoppedStreams,
      pendingRequest: hadPendingRequest
    });
  }

  function notifySelfieCameraResumeFailure(source, error) {
    var widget = document.querySelector(".basedai-widget");
    if (widget) {
      widget.setAttribute("data-basedai-camera-recovery", "failed");
      var buttons = Array.prototype.slice.call(widget.querySelectorAll("button"));
      var selfieButton = buttons.find(function (button) {
        return isWidgetAction(button, /^TAKE SELFIE$/i);
      });
      var errorNode = widget.querySelector(".basedai-photo-consent-error");
      if (!errorNode && selfieButton && selfieButton.parentNode) {
        errorNode = document.createElement("p");
        errorNode.className = "basedai-photo-consent-error";
        selfieButton.parentNode.insertBefore(errorNode, selfieButton);
      }
      if (errorNode) {
        errorNode.textContent =
          "Camera paused. Tap Take Selfie to reopen it, or use Upload from Library.";
        errorNode.hidden = false;
      }
      if (selfieButton) {
        selfieButton.disabled = false;
        selfieButton.removeAttribute("aria-disabled");
        selfieButton.classList.remove("basedai-photo-action-disabled");
      }
    }
    try {
      window.dispatchEvent(new CustomEvent("basedai:camera-resume-failed", {
        detail: {
          source: source || "unknown",
          name: error && error.name ? error.name : "Error"
        }
      }));
    } catch (_) {}
  }

  function clearSelfieCameraResumeFailure() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget || widget.getAttribute("data-basedai-camera-recovery") !== "failed") return;
    widget.removeAttribute("data-basedai-camera-recovery");
    var errorNode = widget.querySelector(".basedai-photo-consent-error");
    if (errorNode) {
      errorNode.textContent = "";
      errorNode.hidden = true;
    }
  }

  function reacquireSelfieCameraVideos(source, options) {
    if (!isSelfieCameraPageVisible()) return;
    if (!lastSelfieCameraRequest || typeof lastSelfieCameraRequest.nativeGetUserMedia !== "function") return;
    var force = !!(options && options.force) || selfieCameraWasSuspended;
    var videos = force ? findVisibleSelfieCameraVideos() : findActiveSelfieCameraVideos();
    if (!videos.length) {
      recordDiagnostic("camera_resume_reacquire_skipped", {
        source: source || "unknown",
        reason: "no_visible_video",
        force: force
      });
      return;
    }
    var now = Date.now();
    if (selfieCameraResumeReacquireInFlight || selfieCameraRequestInFlightCount > 0) {
      selfieCameraResumePending = true;
      selfieCameraResumePendingSource = source || "resume";
      return;
    }
    if (!force && now - lastSelfieCameraResumeReacquireAt < SELFIE_CAMERA_REACQUIRE_MIN_INTERVAL_MS) return;

    selfieCameraResumeReacquireInFlight = true;
    lastSelfieCameraResumeReacquireAt = now;
    var cameraRequest = lastSelfieCameraRequest;
    var reacquireSucceeded = false;
    var reacquireCanceled = false;
    refreshSelfieCameraRequestOwner(cameraRequest, videos[0]);
    var resumeGeneration = selfieCameraResumeGeneration;
    recordDiagnostic("camera_resume_reacquire_requested", {
      source: source || "unknown",
      videos: videos.length,
      force: force
    });
    detachSelfieCameraVideos(videos, source || "resume");

    requestResumeSelfieCameraStream(cameraRequest, source || "resume", 0)
      .then(function (stream) {
        if (!isSelfieCameraPageVisible() ||
          resumeGeneration !== selfieCameraResumeGeneration ||
          cameraRequest !== lastSelfieCameraRequest) {
          if (
            cameraRequest !== lastSelfieCameraRequest ||
            stream !== cameraRequest.publicStream
          ) {
            stopSelfieCameraStream(stream);
          }
          recordDiagnostic("camera_resume_reacquire_canceled", {
            source: source || "unknown",
            visibility: document.visibilityState || "",
            stale: resumeGeneration !== selfieCameraResumeGeneration,
            requestChanged: cameraRequest !== lastSelfieCameraRequest
          });
          return;
        }
        return attachSelfieCameraStreamToVideos(
          videos,
          stream,
          (source || "resume") + ":reacquire",
          {
            cameraRequest: cameraRequest,
            requestGeneration: resumeGeneration
          }
        )
          .then(function (currentVideos) {
            recordDiagnostic("camera_resume_reacquire_resolved", {
              source: source || "unknown",
              videos: currentVideos.length
            });
            selfieCameraWasSuspended = false;
            clearSelfieCameraResumeFailure();
            reacquireSucceeded = true;
          });
      })
      .catch(function (error) {
        var lifecycleChanged =
          !isSelfieCameraPageVisible() ||
          resumeGeneration !== selfieCameraResumeGeneration ||
          cameraRequest !== lastSelfieCameraRequest;
        if ((error && error.basedaiCameraResumeCanceled) || lifecycleChanged) {
          reacquireCanceled = true;
          recordDiagnostic("camera_resume_reacquire_canceled", {
            source: source || "unknown",
            visibility: document.visibilityState || "",
            stale: resumeGeneration !== selfieCameraResumeGeneration,
            requestChanged: cameraRequest !== lastSelfieCameraRequest
          });
        } else {
          recordDiagnostic("camera_resume_reacquire_failed", {
            source: source || "unknown",
            message: error && error.message ? error.message : String(error)
          });
          notifySelfieCameraResumeFailure(source || "resume", error);
        }
      })
      .then(function () {
        selfieCameraResumeReacquireInFlight = false;
        var shouldResumePending =
          selfieCameraResumePending &&
          isSelfieCameraPageVisible() &&
          cameraRequest === lastSelfieCameraRequest;
        var pendingSource = selfieCameraResumePendingSource || source || "resume";
        selfieCameraResumePending = false;
        selfieCameraResumePendingSource = "";
        if (shouldResumePending && (reacquireSucceeded || reacquireCanceled)) {
          scheduleSelfieCameraResumeRetune(pendingSource + ":pending");
        }
      });
  }

  function retuneActiveSelfieCameraTracks(source) {
    if (document.visibilityState && document.visibilityState !== "visible") return;
    pruneSelfieCameraStreams();
    var tracks = [];
    activeSelfieCameraStreams.forEach(function (stream) {
      try {
        stream.getVideoTracks().forEach(function (track) {
          if (track && track.readyState !== "ended") tracks.push(track);
        });
      } catch (_) {}
    });
    if (!tracks.length) return;
    recordDiagnostic("camera_resume_retune_requested", {
      source: source || "unknown",
      tracks: tracks.length
    });
    tracks.forEach(function (track) {
      applyNeutralSelfieCameraZoom(track, source || "resume");
    });
    resumeSelfieCameraVideos(source || "resume");
  }

  function scheduleSelfieCameraResumeRetune(source) {
    if (!isSelfieCameraPageVisible()) return;
    selfieCameraResumeScheduleId += 1;
    var scheduleId = selfieCameraResumeScheduleId;
    selfieCameraResumeTimerIds.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    selfieCameraResumeTimerIds = [];
    [0, 250, 900, 1600].forEach(function (delay) {
      scheduleSelfieCameraResumeTimer(function () {
        if (scheduleId !== selfieCameraResumeScheduleId || !isSelfieCameraPageVisible()) return;
        retuneActiveSelfieCameraTracks((source || "resume") + ":" + delay);
      }, delay);
    });
    scheduleSelfieCameraResumeTimer(function () {
      if (scheduleId !== selfieCameraResumeScheduleId || !isSelfieCameraPageVisible()) return;
      if (!selfieCameraWasSuspended) return;
      reacquireSelfieCameraVideos((source || "resume") + ":reacquire", { force: true });
    }, 350);
  }

  function installSelfieCameraResumeRetune() {
    if (cameraResumeListenersInstalled) return;
    cameraResumeListenersInstalled = true;
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        suspendSelfieCameraVideos("visibilitychange:hidden");
      } else {
        scheduleSelfieCameraResumeRetune("visibilitychange");
      }
    });
    window.addEventListener("pagehide", function () {
      suspendSelfieCameraVideos("pagehide");
    });
    window.addEventListener("pageshow", function () {
      scheduleSelfieCameraResumeRetune("pageshow");
    });
    window.addEventListener("focus", function () {
      scheduleSelfieCameraResumeRetune("focus");
    });
  }

  function recordAvailableCameraDevices() {
    try {
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.enumerateDevices !== "function") return;
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          var videoInputs = devices
            .filter(function (device) {
              return device && device.kind === "videoinput";
            })
            .map(function (device) {
              return { label: device.label || "" };
            });
          recordDiagnostic("camera_devices_available", { videoInputs: videoInputs });
        })
        .catch(function (error) {
          recordDiagnostic("camera_devices_unavailable", {
            message: error && error.message ? error.message : String(error)
          });
        });
    } catch (_) {}
  }

  function tuneSelfieCameraTrack(stream) {
    try {
      if (!stream || typeof stream.getVideoTracks !== "function") return stream;
      var track = stream.getVideoTracks()[0];
      if (!track) return stream;

      var settings = typeof track.getSettings === "function" ? track.getSettings() : {};
      var capabilities = typeof track.getCapabilities === "function" ? track.getCapabilities() : {};
      recordDiagnostic("camera_track_selected", {
        label: track.label || "",
        settings: pickCameraSettings(settings),
        capabilities: pickCameraCapabilities(capabilities)
      });
      recordAvailableCameraDevices();

      applyNeutralSelfieCameraZoom(track, "initial");
    } catch (error) {
      recordDiagnostic("camera_track_tune_failed", {
        message: error && error.message ? error.message : String(error)
      });
    }
    return stream;
  }

  function adoptSelfieCameraCandidateStream(cameraRequest, candidateStream) {
    if (!cameraRequest.publicStream) {
      cameraRequest.publicStream = candidateStream;
      return candidateStream;
    }
    if (cameraRequest.publicStream === candidateStream) {
      return candidateStream;
    }

    var publicStream = cameraRequest.publicStream;
    var oldTracks = [];
    var candidateTracks = [];
    var adoptedTracks = [];
    try {
      oldTracks = typeof publicStream.getTracks === "function"
        ? publicStream.getTracks().slice()
        : [];
      candidateTracks = typeof candidateStream.getTracks === "function"
        ? candidateStream.getTracks().slice()
        : [];
      candidateTracks.forEach(function (track) {
        publicStream.addTrack(track);
        adoptedTracks.push(track);
      });
    } catch (error) {
      adoptedTracks.forEach(function (track) {
        try {
          publicStream.removeTrack(track);
        } catch (_) {}
      });
      stopSelfieCameraStream(candidateStream);
      throw error;
    }

    candidateTracks.forEach(function (track) {
      try {
        if (typeof candidateStream.removeTrack === "function") {
          candidateStream.removeTrack(track);
        }
      } catch (_) {}
    });
    oldTracks.forEach(function (track) {
      try {
        if (typeof publicStream.removeTrack === "function") {
          publicStream.removeTrack(track);
        }
        forgetObservedSelfieCameraTrack(track);
        if (track && typeof track.stop === "function" && track.readyState !== "ended") {
          track.stop();
        }
      } catch (_) {}
    });
    recordDiagnostic("camera_stream_tracks_replaced", {
      requestId: cameraRequest.id || 0,
      tracks: candidateTracks.length
    });
    return publicStream;
  }

  function requestSelfieCamera(nativeGetUserMedia, constraints, options) {
    installSelfieCameraResumeRetune();
    var internalRequest = options && options.cameraRequest;
    var keepCallerPending = !internalRequest || !!(options && options.keepCallerPending);
    var cameraRequest;
    if (internalRequest) {
      if (internalRequest !== lastSelfieCameraRequest) {
        return Promise.reject(
          selfieCameraCancellationError("Camera request canceled because a newer request is active.")
        );
      }
      cameraRequest = internalRequest;
      nativeGetUserMedia = cameraRequest.nativeGetUserMedia;
      constraints = cameraRequest.constraints;
    } else {
      if (
        lastSelfieCameraRequest &&
        typeof lastSelfieCameraRequest.cancelVisibilityWait === "function"
      ) {
        lastSelfieCameraRequest.cancelVisibilityWait();
      }
      cameraRequest = {
        id: ++selfieCameraRequestSequence,
        nativeGetUserMedia: nativeGetUserMedia,
        constraints: constraints,
        ownerVideo: findSelfieCameraOwnerVideo(),
        publicStream: null
      };
      cameraRequest.ownerWidget = findSelfieCameraOwnerWidget(cameraRequest.ownerVideo);
      cameraRequest.ownerVideoRequired = !!cameraRequest.ownerVideo;
      lastSelfieCameraRequest = cameraRequest;
    }

    var attempts = selfieCameraConstraintAttempts(constraints);
    var requestSource = (options && options.source) || "initial";
    selfieCameraRequestInFlightCount += 1;

    function requestIsCurrent(requestGeneration) {
      return (
        isSelfieCameraPageVisible() &&
        requestGeneration === selfieCameraResumeGeneration &&
        cameraRequest === lastSelfieCameraRequest &&
        selfieCameraRequestOwnerIsAvailable(cameraRequest)
      );
    }

    function canceledRequestError() {
      return selfieCameraCancellationError(
        "Camera request canceled because the page or active request changed."
      );
    }

    function requestCycle() {
      var requestGeneration = selfieCameraResumeGeneration;

      function requestAttempt(index, previousError) {
        if (!requestIsCurrent(requestGeneration)) return Promise.reject(canceledRequestError());
        var attempt = attempts[index];
        recordDiagnostic(index === 0 ? "camera_constraints_requested" : "camera_constraints_retry_requested", {
          attempt: attempt.label,
          constraints: attempt.constraints,
          previousError: previousError ? cameraErrorSummary(previousError) : null
        });

        return Promise.resolve()
          .then(function () {
            if (!requestIsCurrent(requestGeneration)) throw canceledRequestError();
            return runSerializedSelfieCameraAcquisition(function () {
              if (!requestIsCurrent(requestGeneration)) throw canceledRequestError();
              return nativeGetUserMedia(attempt.constraints);
            });
          })
          .then(function (stream) {
            if (!requestIsCurrent(requestGeneration)) {
              stopSelfieCameraStream(stream);
              throw canceledRequestError();
            }
            recordDiagnostic("camera_constraints_resolved", { attempt: attempt.label });
            return stream;
          })
          .catch(function (error) {
            if (error && error.basedaiCameraResumeCanceled) throw error;
            if (!requestIsCurrent(requestGeneration)) throw canceledRequestError();
            recordDiagnostic(index === 0 ? "camera_constraints_failed" : "camera_constraints_retry_failed", Object.assign({
              attempt: attempt.label
            }, cameraErrorSummary(error)));
            if (index + 1 < attempts.length && shouldRetrySelfieCamera(error)) {
              return requestAttempt(index + 1, error);
            }
            throw error;
          });
      }

      return requestAttempt(0).then(function (stream) {
        if (!requestIsCurrent(requestGeneration)) {
          stopSelfieCameraStream(stream);
          throw canceledRequestError();
        }
        stream = adoptSelfieCameraCandidateStream(cameraRequest, stream);
        if (!requestIsCurrent(requestGeneration)) {
          stopSelfieCameraStream(stream);
          throw canceledRequestError();
        }
        trackSelfieCameraStream(stream);
        selfieCameraWasSuspended = false;
        clearSelfieCameraResumeFailure();
        stream = tuneSelfieCameraTrack(stream);

        if (!keepCallerPending) return stream;
        var ownerVideo = refreshSelfieCameraRequestOwner(cameraRequest);
        if (!ownerVideo) {
          stopSelfieCameraStreamUnlessAttached(stream, cameraRequest);
          return stream;
        }
        return attachSelfieCameraStreamToVideos(
          [ownerVideo],
          stream,
          requestSource + ":initial-handoff",
          {
            allowHiddenVideos: true,
            cameraRequest: cameraRequest,
            requestGeneration: requestGeneration,
            requireReady: false
          }
        ).then(function () {
          return stream;
        });
      });
    }

    function waitForCallerOwnedRetry(retryAttempt, error) {
      var lifecycleCancellation = Boolean(error && error.basedaiCameraResumeCanceled);
      var requestStillOwned =
        cameraRequest === lastSelfieCameraRequest &&
        selfieCameraRequestOwnerIsAvailable(cameraRequest);
      if (!keepCallerPending || !requestStillOwned) throw error;
      if (!lifecycleCancellation && !shouldRetrySelfieCamera(error)) throw error;
      if (
        !lifecycleCancellation &&
        retryAttempt >= SELFIE_CAMERA_RESUME_RESTART_MAX_ATTEMPTS
      ) {
        throw error;
      }

      recordDiagnostic("camera_initial_request_resume_waiting", {
        source: requestSource,
        visibility: document.visibilityState || "",
        retryAttempt: retryAttempt
      });

      var delayPromise = lifecycleCancellation
        ? Promise.resolve()
        : wait(SELFIE_CAMERA_RESUME_RESTART_DELAY_MS * (retryAttempt + 1));
      return delayPromise
        .then(function () {
          return waitForSelfieCameraPageVisible(cameraRequest);
        })
        .then(function () {
          if (
            cameraRequest !== lastSelfieCameraRequest ||
            !selfieCameraRequestOwnerIsAvailable(cameraRequest)
          ) {
            throw selfieCameraCancellationError(
              "Camera request canceled because a newer request is active."
            );
          }
          recordDiagnostic("camera_initial_request_resuming", {
            source: requestSource,
            retryAttempt: retryAttempt
          });
          return runCallerOwnedRequest(
            lifecycleCancellation ? retryAttempt : retryAttempt + 1
          );
        });
    }

    function runCallerOwnedRequest(retryAttempt) {
      return requestCycle().catch(function (error) {
        return waitForCallerOwnedRetry(retryAttempt || 0, error);
      });
    }

    var requestPromise = keepCallerPending
      ? runCallerOwnedRequest(0)
      : requestCycle();

    function finishSelfieCameraRequest() {
      selfieCameraRequestInFlightCount = Math.max(0, selfieCameraRequestInFlightCount - 1);
      if (keepCallerPending && selfieCameraRequestInFlightCount === 0) {
        selfieCameraResumePending = false;
        selfieCameraResumePendingSource = "";
      }
    }

    return requestPromise.then(
      function (stream) {
        finishSelfieCameraRequest();
        return stream;
      },
      function (error) {
        finishSelfieCameraRequest();
        throw error;
      }
    );
  }

  function cameraUnavailableError() {
    return new Error("Camera unavailable in this browser. Use Upload from Library.");
  }

  function isPrivateKey(key) {
    return String(key || "").indexOf(PRIVATE_KEY_PREFIX) === 0;
  }

  function shouldSkipPrivateStorageValue(key, value) {
    var text = String(value || "");
    return (
      String(key) === "basedai_resultUrl" &&
      /^data:image\//i.test(text) &&
      text.length > MAX_PRIVATE_STORAGE_VALUE_CHARS
    );
  }

  function clearPersistentWidgetState() {
    try {
      PRIVATE_KEYS.forEach(function (key) {
        window.localStorage.removeItem(key);
      });
    } catch (_) {}
  }

  function installEphemeralStorageShim() {
    if (window.__BasedAIPrivacyStorageInstalled) return;
    window.__BasedAIPrivacyStorageInstalled = true;
    clearPersistentWidgetState();

    try {
      var proto = window.Storage && window.Storage.prototype;
      if (!proto) return;
      var nativeGetItem = proto.getItem;
      var nativeSetItem = proto.setItem;
      var nativeRemoveItem = proto.removeItem;

      proto.getItem = function (key) {
        if (this === window.localStorage && isPrivateKey(key)) {
          return nativeGetItem.call(window.sessionStorage, key);
        }
        return nativeGetItem.call(this, key);
      };

      proto.setItem = function (key, value) {
        if (this === window.localStorage && isPrivateKey(key)) {
          if (shouldSkipPrivateStorageValue(key, value)) {
            try {
              nativeRemoveItem.call(window.sessionStorage, key);
            } catch (_) {}
            recordDiagnostic("private_storage_skipped_large_result", {
              key: String(key),
              chars: String(value || "").length
            });
            return;
          }
          try {
            return nativeSetItem.call(window.sessionStorage, key, value);
          } catch (error) {
            recordDiagnostic("private_storage_write_failed", {
              key: String(key),
              chars: String(value || "").length,
              message: error && error.message ? error.message : String(error)
            });
            return;
          }
        }
        return nativeSetItem.call(this, key, value);
      };

      proto.removeItem = function (key) {
        if (this === window.localStorage && isPrivateKey(key)) {
          return nativeRemoveItem.call(window.sessionStorage, key);
        }
        return nativeRemoveItem.call(this, key);
      };
    } catch (_) {}
  }

  function isStartJobUrl(url) {
    var href = String(url || "");
    var host = "";
    try {
      host = new URL(href, window.location.href).hostname.toLowerCase();
    } catch (_) {}
    return /\/startJob(?:[?#]|$)/.test(href) || /^startjob-/.test(host);
  }

  function isClaimJobUrl(url) {
    var href = String(url || "");
    var host = "";
    try {
      host = new URL(href, window.location.href).hostname.toLowerCase();
    } catch (_) {}
    return /\/claimJob(?:[?#]|$)/.test(href) || /^claimjob-/.test(host);
  }

  function isGetJobUrl(url) {
    var href = String(url || "");
    var host = "";
    try {
      host = new URL(href, window.location.href).hostname.toLowerCase();
    } catch (_) {}
    return /\/getJob(?:[?#]|$)/.test(href) || /^getjob-/.test(host);
  }

  function isLegacyOptinWebhookUrl(url) {
    return String(url || "").indexOf("n8n.cortexx.app/webhook/hairscanner-optins") !== -1;
  }

  function createSessionUrlForStartJob(url) {
    try {
      var parsed = new URL(String(url || ""), window.location.href);
      if (/^startjob-/.test(parsed.hostname.toLowerCase())) {
        parsed.hostname = parsed.hostname.replace(/^startjob-/i, "createsession-");
        return parsed.toString();
      }
      parsed.pathname = parsed.pathname.replace(/\/startJob(?:\/)?$/i, "/createSession");
      return parsed.toString();
    } catch (_) {
      return String(url || "").replace(/startJob/g, "createSession").replace(/startjob-/i, "createsession-");
    }
  }

  function isProtectedPost(url, init) {
    var method = String((init && init.method) || "GET").toUpperCase();
    if (method !== "POST") return false;
    var href = String(url || "");
    var host = "";
    try {
      host = new URL(href, window.location.href).hostname.toLowerCase();
    } catch (_) {}
    return (
      /\/startJob(?:[?#]|$)/.test(href) ||
      /\/claimJob(?:[?#]|$)/.test(href) ||
      /^startjob-/.test(host) ||
      /^claimjob-/.test(host)
    );
  }

  function headersToObject(headers) {
    var out = {};
    if (!headers) return out;
    if (headers instanceof Headers) {
      headers.forEach(function (value, key) {
        out[key] = value;
      });
      return out;
    }
    if (Array.isArray(headers)) {
      headers.forEach(function (entry) {
        out[entry[0]] = entry[1];
      });
      return out;
    }
    return Object.assign({}, headers);
  }

  function optionId(option) {
    return String((option && option.id) || "").toLowerCase();
  }

  function optionLabel(option) {
    return String((option && option.label) || "").trim();
  }

  function writeSessionValue(key, value) {
    try {
      if (value) window.sessionStorage.setItem(key, value);
    } catch (_) {}
  }

  function readSessionValue(key) {
    try {
      return window.sessionStorage.getItem(key) || "";
    } catch (_) {
      return "";
    }
  }

  function appendClaimTokenToGetJobInput(input) {
    var claimToken = readSessionValue("basedai_claimToken");
    if (!claimToken) return input;
    try {
      var url = typeof input === "string" ? input : input && input.url;
      var parsed = new URL(String(url || ""), window.location.href);
      if (!parsed.searchParams.get("claimToken")) {
        parsed.searchParams.set("claimToken", claimToken);
      }
      if (typeof input === "string") return parsed.toString();
      return new Request(parsed.toString(), input);
    } catch (_) {
      return input;
    }
  }

  function clearClaimToken() {
    try {
      window.sessionStorage.removeItem("basedai_claimToken");
    } catch (_) {}
  }

  function clearGenerationSessionToken() {
    try {
      window.sessionStorage.removeItem("basedai_sessionToken");
      window.sessionStorage.removeItem("basedai_sessionTokenExpiresAt");
    } catch (_) {}
  }

  function readCachedGenerationSessionToken() {
    var token = readSessionValue("basedai_sessionToken");
    var expiresAt = Number(readSessionValue("basedai_sessionTokenExpiresAt") || 0);
    if (token && expiresAt && expiresAt - Date.now() > 30000) return token;
    return "";
  }

  function storeGenerationSessionToken(body) {
    if (!body || !body.sessionToken) return "";
    var expiresAtMs = Date.parse(body.expiresAt || "");
    if (!Number.isFinite(expiresAtMs)) expiresAtMs = Date.now() + 10 * 60 * 1000;
    writeSessionValue("basedai_sessionToken", String(body.sessionToken));
    writeSessionValue("basedai_sessionTokenExpiresAt", String(expiresAtMs));
    return String(body.sessionToken);
  }

  function hasTurnstileSiteKey() {
    return Boolean(turnstileSiteKey && String(turnstileSiteKey).trim());
  }

  function ensureTurnstileContainer() {
    if (turnstileContainer && document.body.contains(turnstileContainer)) return turnstileContainer;
    turnstileContainer = document.createElement("div");
    turnstileContainer.id = "basedai-turnstile";
    turnstileContainer.style.position = "fixed";
    turnstileContainer.style.left = "-9999px";
    turnstileContainer.style.width = "1px";
    turnstileContainer.style.height = "1px";
    turnstileContainer.style.overflow = "hidden";
    turnstileContainer.setAttribute("aria-hidden", "true");
    document.body.appendChild(turnstileContainer);
    return turnstileContainer;
  }

  function loadTurnstileApi() {
    if (!hasTurnstileSiteKey()) return Promise.resolve(null);
    if (window.turnstile && typeof window.turnstile.render === "function") {
      return Promise.resolve(window.turnstile);
    }
    if (turnstileScriptPromise) return turnstileScriptPromise;
    turnstileScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
      if (existing) {
        existing.addEventListener("load", function () { resolve(window.turnstile || null); }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }
      var tag = document.createElement("script");
      tag.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      tag.async = true;
      tag.defer = true;
      tag.onload = function () { resolve(window.turnstile || null); };
      tag.onerror = function () { reject(new Error("Turnstile could not load.")); };
      document.head.appendChild(tag);
    });
    return turnstileScriptPromise;
  }

  function fetchTurnstileToken() {
    if (!hasTurnstileSiteKey()) return Promise.resolve("");
    return loadTurnstileApi().then(function (turnstile) {
      if (!turnstile || typeof turnstile.render !== "function" || typeof turnstile.execute !== "function") {
        throw new Error("Turnstile unavailable.");
      }
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timeout = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          reject(new Error("Turnstile timed out."));
        }, 10000);

        function finish(token) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          resolve(String(token || ""));
        }

        try {
          if (turnstileWidgetId !== null && typeof turnstile.reset === "function") {
            turnstile.reset(turnstileWidgetId);
          }
          if (turnstileWidgetId === null) {
            turnstileWidgetId = turnstile.render(ensureTurnstileContainer(), {
              sitekey: String(turnstileSiteKey).trim(),
              size: "invisible",
              action: "hair_iq_create_session",
              callback: finish,
              "error-callback": function () {
                if (!settled) {
                  settled = true;
                  window.clearTimeout(timeout);
                  reject(new Error("Turnstile failed."));
                }
              },
              "expired-callback": function () {
                if (!settled) {
                  settled = true;
                  window.clearTimeout(timeout);
                  reject(new Error("Turnstile expired."));
                }
              }
            });
          }
          turnstile.execute(turnstileWidgetId);
        } catch (err) {
          if (!settled) {
            settled = true;
            window.clearTimeout(timeout);
            reject(err);
          }
        }
      });
    });
  }

  function fetchGenerationSessionToken(startJobUrl, nativeFetch) {
    var cached = readCachedGenerationSessionToken();
    if (cached) return Promise.resolve(cached);
    var sessionUrl = createSessionUrlForStartJob(startJobUrl);
    return fetchTurnstileToken().then(function (turnstileToken) {
      var headers = { "Content-Type": "application/json" };
      var body = { version: CONSENT_VERSION };
      if (turnstileToken) {
        headers["X-Based-Turnstile-Token"] = turnstileToken;
        body.turnstileToken = turnstileToken;
      }
      return nativeFetch(sessionUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status === 429 ? "Too many generation attempts." : "Could not start generation.");
      }
      return response.json();
    }).then(storeGenerationSessionToken);
  }

  function storeStartJobClaimToken(response) {
    try {
      response
        .clone()
        .json()
        .then(function (body) {
          if (body && body.jobId) writeSessionValue("basedai_jobId", String(body.jobId));
          if (body && body.claimToken) writeSessionValue("basedai_claimToken", String(body.claimToken));
        })
        .catch(function () {});
    } catch (_) {}
  }

  function writeSelectionState(body) {
    try {
      if (!body || !body.style || !body.type || !body.color) return;
      var styleId = optionId(body.style);
      var typeId = optionId(body.type);
      var colorId = optionId(body.color);
      var styleLabel = optionLabel(body.style);
      var typeLabel = optionLabel(body.type);
      var colorLabel = optionLabel(body.color);
      var pendingLabel = [typeLabel, colorLabel, styleLabel].filter(Boolean).join(" ");
      writeSessionValue("basedai_styleId", styleId);
      writeSessionValue("basedai_styleLabel", styleLabel);
      writeSessionValue("basedai_typeId", typeId);
      writeSessionValue("basedai_typeLabel", typeLabel);
      writeSessionValue("basedai_colorId", colorId);
      writeSessionValue("basedai_colorLabel", colorLabel);
      writeSessionValue("basedai_pending_label", pendingLabel);
    } catch (_) {}
  }

  function clearGenerationError() {
    try {
      window.sessionStorage.removeItem(GENERATION_ERROR_KEY);
    } catch (_) {}
    setLoadingProgressHidden(document.querySelector(".basedai-widget"), false);
    var panel = document.querySelector("#basedai-loading-upgrade");
    if (panel) panel.classList.remove("basedai-loading-upgrade--error");
  }

  function readGenerationError() {
    try {
      var raw = window.sessionStorage.getItem(GENERATION_ERROR_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  function retryAfterText(seconds) {
    var total = Math.max(0, Number(seconds || 0));
    if (!total) return "";
    var minutes = Math.ceil(total / 60);
    if (minutes <= 1) return "about 1 minute";
    return "about " + minutes + " minutes";
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, Math.max(0, Number(ms || 0)));
    });
  }

  function retryAfterSecondsFromResponse(response) {
    try {
      var raw = response.headers.get("Retry-After");
      if (!raw) return 0;
      var seconds = Number(raw);
      if (Number.isFinite(seconds)) return Math.max(0, seconds);
      var dateMs = Date.parse(raw);
      return Number.isFinite(dateMs) ? Math.max(0, Math.ceil((dateMs - Date.now()) / 1000)) : 0;
    } catch (_) {
      return 0;
    }
  }

  function startJobRetryDelayMs(response, attempt) {
    var retryAfterSeconds = retryAfterSecondsFromResponse(response);
    if (retryAfterSeconds > 0 && retryAfterSeconds <= 120) {
      return retryAfterSeconds * 1000;
    }
    var jitter = Math.floor(Math.random() * 2500);
    var exponential = START_JOB_BUSY_BASE_DELAY_MS * Math.pow(1.7, Math.max(0, attempt));
    return Math.min(START_JOB_BUSY_MAX_DELAY_MS, Math.round(exponential + jitter));
  }

  function shouldRetryStartJobResponse(response, startedAt, attempt) {
    if (!response) return false;
    if (![429, 502, 503, 504].includes(Number(response.status))) return false;
    var retryAfterSeconds = retryAfterSecondsFromResponse(response);
    if (retryAfterSeconds > 120) return false;
    if (attempt >= 16) return false;
    return Date.now() - startedAt < START_JOB_BUSY_MAX_WAIT_MS;
  }

  function drainResponse(response) {
    try {
      return response.clone().text().catch(function () {});
    } catch (_) {
      return Promise.resolve();
    }
  }

  function storeGenerationError(detail) {
    var payload = Object.assign(
      {
        status: 0,
        message: "Generation did not finish.",
        retryAfterSeconds: 0,
        at: nowIso()
      },
      detail || {}
    );
    try {
      window.sessionStorage.setItem(GENERATION_ERROR_KEY, JSON.stringify(payload));
    } catch (_) {}
    recordDiagnostic("generation_error", payload);
    pushAnalyticsEvent("basedai_generation_failed", {
      status: Number(payload.status || 0),
      code: payload.code || null,
      retry_after_seconds: Number(payload.retryAfterSeconds || 0),
      result_label: readPendingLabel() || readResultLabel() || null
    });
    renderGenerationErrorExperience();
  }

  function storeStartJobResponseError(response) {
    var retryAfterSeconds = 0;
    try {
      retryAfterSeconds = Number(response.headers.get("Retry-After") || 0);
    } catch (_) {}
    var fallback = {
      status: response.status,
      message: response.status === 429 ? "Too many generation attempts." : "Generation did not finish.",
      retryAfterSeconds: retryAfterSeconds
    };
    try {
      response
        .clone()
        .json()
        .then(function (body) {
          storeGenerationError(
            Object.assign({}, fallback, {
              message: (body && (body.error || body.message)) || fallback.message,
              code: body && body.code,
              retryAfterSeconds: Number(body && body.retryAfterSeconds) || fallback.retryAfterSeconds,
              jobId: body && body.jobId
            })
          );
        })
        .catch(function () {
          storeGenerationError(fallback);
        });
    } catch (_) {
      storeGenerationError(fallback);
    }
  }

  function installConsentFetchShim() {
    if (window.__BasedAIPrivacyFetchInstalled) return;
    window.__BasedAIPrivacyFetchInstalled = true;
    var nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var nextInit = init ? Object.assign({}, init) : {};
      var isStartJob = isStartJobUrl(url);
      var isClaimJob = isClaimJobUrl(url);
      var isGetJob = isGetJobUrl(url);
      var requestInput = isGetJob ? appendClaimTokenToGetJobInput(input) : input;
      if (isLegacyOptinWebhookUrl(url)) {
        recordDiagnostic("legacy_optin_webhook_skipped", { at: nowIso() });
        return Promise.resolve(new Response(JSON.stringify({
          skipped: true,
          reason: "legacy_optin_webhook_disabled"
        }), {
          status: 200,
          headers: { "Content-Type": "application/json" }
        }));
      }
      var startJobBody = null;
      if (isProtectedPost(url, nextInit)) {
        var consent = readConsent();
        if (!consent) {
          return Promise.reject(new Error("Privacy consent required"));
        }

        if (typeof nextInit.body === "string") {
          try {
            var body = JSON.parse(nextInit.body);
            if (isStartJob) {
              clearGenerationError();
              clearClaimToken();
              clearGenerationSessionToken();
              writeSelectionState(body);
              pushAnalyticsEvent("basedai_generation_started", {
                result_label: readPendingLabel() || null
              });
            }
            if (isClaimJob) {
              var claimToken = readSessionValue("basedai_claimToken");
              if (claimToken) body.claimToken = claimToken;
              pushAnalyticsEvent("basedai_unlock_started", {
                job_id_present: Boolean(body.jobId),
                customer_email_present: Boolean(body.customerEmail),
                customer_id_present: Boolean(body.customerId),
                marketing_consent: consent.marketingConsent === true
              });
            }
            body.privacyConsent = consent;
            body.consentVersion = consent.version;
            body.age18Plus = true;
            body.termsAccepted = true;
            body.biometricConsent = true;
            body.aiProcessingConsent = true;
            body.privacyPolicyAccepted = true;
            body.marketingConsent = consent.marketingConsent === true;
            if (isStartJob) startJobBody = body;
            nextInit.body = JSON.stringify(body);
            nextInit.headers = Object.assign(headersToObject(nextInit.headers), {
              "Content-Type": "application/json"
            });
          } catch (_) {}
        }
      }
      function sendFetchOnce() {
        return nativeFetch(requestInput, nextInit).then(
        function (response) {
          if (isStartJob) {
            if (response.ok) {
              clearGenerationError();
              storeStartJobClaimToken(response);
              pushAnalyticsEvent("basedai_generation_succeeded", {
                status: response.status,
                result_label: readPendingLabel() || readResultLabel() || null
              });
            }
          }
          if (isClaimJob) {
            if (response.ok) {
              pushAnalyticsEvent("basedai_unlock_succeeded", {
                status: response.status,
                result_label: readResultLabel() || readPendingLabel() || null
              });
            } else {
              pushAnalyticsEvent("basedai_unlock_failed", {
                status: response.status,
                result_label: readResultLabel() || readPendingLabel() || null
              });
            }
          }
          return response;
        },
        function (error) {
          if (isStartJob) {
            storeGenerationError({
              status: 0,
              message: error && error.message ? error.message : "Network error while generating."
            });
          }
          if (isClaimJob) {
            pushAnalyticsEvent("basedai_unlock_failed", {
              status: 0,
              code: "network_error",
              result_label: readResultLabel() || readPendingLabel() || null
            });
          }
          throw error;
        }
      );
      }
      function sendFetch() {
        if (!isStartJob || !startJobBody) return sendFetchOnce();
        var startedAt = Date.now();
        function attemptStartJob(attempt) {
          return sendFetchOnce().then(function (response) {
            if (response.ok) return response;
            if (!shouldRetryStartJobResponse(response, startedAt, attempt)) {
              storeStartJobResponseError(response);
              return response;
            }
            var delayMs = startJobRetryDelayMs(response, attempt);
            recordDiagnostic("generation_busy_retry", {
              status: response.status,
              retryAfterSeconds: retryAfterSecondsFromResponse(response),
              delayMs: delayMs,
              attempt: attempt + 1
            });
            pushAnalyticsEvent("basedai_generation_retry", {
              status: response.status,
              retry_after_seconds: retryAfterSecondsFromResponse(response),
              delay_ms: delayMs,
              attempt: attempt + 1,
              result_label: readPendingLabel() || readResultLabel() || null
            });
            return drainResponse(response)
              .then(function () {
                return wait(delayMs);
              })
              .then(function () {
                clearGenerationSessionToken();
                return fetchGenerationSessionToken(url, nativeFetch);
              })
              .then(function (sessionToken) {
                startJobBody.sessionToken = sessionToken;
                nextInit.body = JSON.stringify(startJobBody);
                return attemptStartJob(attempt + 1);
              });
          });
        }
        return attemptStartJob(0);
      }
      if (isStartJob && startJobBody) {
        return fetchGenerationSessionToken(url, nativeFetch).then(
          function (sessionToken) {
            startJobBody.sessionToken = sessionToken;
            nextInit.body = JSON.stringify(startJobBody);
            return sendFetch();
          },
          function (error) {
            storeGenerationError({
              status: 0,
              message: error && error.message ? error.message : "Could not start generation."
            });
            throw error;
          }
        );
      }
      return sendFetch();
    };
  }

  function installCameraConsentShim() {
    if (window.__BasedAIPrivacyCameraInstalled) return;
    window.__BasedAIPrivacyCameraInstalled = true;
    try {
      var nav = window.navigator;
      if (!nav) return;
      var mediaDevices = nav.mediaDevices;
      var shimMediaDevices = null;
      var nativeMediaDevices = mediaDevices || null;
      var nativeGetUserMedia =
        mediaDevices && typeof mediaDevices.getUserMedia === "function"
          ? mediaDevices.getUserMedia.bind(mediaDevices)
          : null;

      function currentNativeGetUserMedia() {
        var liveMediaDevices = nav.mediaDevices;
        if (
          liveMediaDevices &&
          liveMediaDevices !== shimMediaDevices &&
          typeof liveMediaDevices.getUserMedia === "function"
        ) {
          if (!nativeGetUserMedia && liveMediaDevices.getUserMedia !== guardedGetUserMedia) {
            nativeGetUserMedia = liveMediaDevices.getUserMedia.bind(liveMediaDevices);
          }
        }
        return nativeGetUserMedia;
      }

      function guardedGetUserMedia(constraints) {
        function startCamera() {
          var getUserMedia = currentNativeGetUserMedia();
          if (!getUserMedia) {
            recordDiagnostic("camera_api_unavailable_after_consent", {});
            return Promise.reject(cameraUnavailableError());
          }
          return requestSelfieCamera(getUserMedia, constraints);
        }

        if (!readConsent()) {
          recordDiagnostic("camera_permission_requested_before_photo_consent", {});
        }
        return startCamera();
      }

      if (mediaDevices && typeof mediaDevices.getUserMedia === "function") {
        mediaDevices.getUserMedia = guardedGetUserMedia;
        return;
      }

      shimMediaDevices = {
        getUserMedia: guardedGetUserMedia,
        enumerateDevices: function () {
          var liveMediaDevices = nav.mediaDevices;
          if (
            liveMediaDevices &&
            liveMediaDevices !== shimMediaDevices &&
            typeof liveMediaDevices.enumerateDevices === "function"
          ) {
            return liveMediaDevices.enumerateDevices();
          }
          if (nativeMediaDevices && typeof nativeMediaDevices.enumerateDevices === "function") {
            return nativeMediaDevices.enumerateDevices();
          }
          return Promise.resolve([]);
        }
      };
      try {
        Object.defineProperty(nav, "mediaDevices", {
          configurable: true,
          enumerable: true,
          value: shimMediaDevices
        });
        recordDiagnostic("camera_api_shim_installed", {});
      } catch (error) {
        recordDiagnostic("camera_api_shim_failed", {
          message: error && error.message ? error.message : String(error)
        });
      }
    } catch (_) {}
  }

  function ensureDisclosureStyles() {
    if (document.getElementById("basedai-inline-consent-style")) return;
    var style = document.createElement("style");
    style.id = "basedai-inline-consent-style";
    style.textContent =
      "@font-face{font-family:'VCR OSD Mono';src:url('" + assetPath("VCR_OSD_MONO_1.001.ttf") + "') format('truetype');font-weight:400;font-style:normal;font-display:swap}" +
      ".basedai-inline-consent-note{box-sizing:border-box;width:min(320px,calc(100vw - 48px));margin:4px auto 0;color:rgba(255,255,255,.56);font:400 11px/1.28 Paralucent,Arial,sans-serif;text-align:center;letter-spacing:0}" +
      ".basedai-inline-consent-note a{color:#d8be69;text-decoration:underline;text-underline-offset:2px}" +
      ".basedai-photo-consent-note{position:relative;z-index:5;pointer-events:auto;box-sizing:border-box;width:min(320px,calc(100vw - 48px));margin:18px auto 0;display:flex;align-items:flex-start;gap:9px;color:rgba(255,255,255,.68);font:400 11px/1.3 Paralucent,Arial,sans-serif;text-align:left;letter-spacing:0;cursor:pointer}" +
      ".basedai-photo-consent-note input{pointer-events:auto;flex:0 0 auto;width:16px;height:16px;margin:0;accent-color:#d8be69;transform:translateY(1px);cursor:pointer}" +
      ".basedai-photo-consent-checkbox{display:inline-block!important;visibility:visible!important;opacity:1!important;position:static!important;box-sizing:border-box!important;-webkit-appearance:auto!important;appearance:auto!important;clip:auto!important;clip-path:none!important;pointer-events:auto!important;flex:0 0 16px!important;width:16px!important;height:16px!important;min-width:16px!important;min-height:16px!important;max-width:16px!important;max-height:16px!important;margin:1px 0 0!important;border:1px solid rgba(216,190,105,.88)!important;border-radius:3px!important;background-color:rgba(0,0,0,.28)!important;accent-color:#d8be69!important;transform:none!important;cursor:pointer!important}" +
      ".basedai-photo-consent-note span{display:block;min-width:0}" +
      ".basedai-photo-consent-note a{pointer-events:auto;color:#d8be69;text-decoration:underline;text-underline-offset:2px;font-weight:600}" +
      ".basedai-photo-consent-error{box-sizing:border-box;width:min(320px,calc(100vw - 48px));margin:6px auto 0;color:#fca5a5;font:500 11px/1.28 Paralucent,Arial,sans-serif;text-align:left;letter-spacing:0}" +
      ".basedai-photo-consent-error[hidden]{display:none!important}" +
      ".basedai-photo-action-disabled{opacity:.48!important;cursor:not-allowed!important}" +
      ".basedai-flow-strip{box-sizing:border-box;width:min(320px,calc(100vw - 48px));margin:12px auto 0;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;font-family:Paralucent,Arial,sans-serif}" +
      ".basedai-flow-step{min-width:0;border:1px solid rgba(255,255,255,.1);border-radius:8px;background:rgba(255,255,255,.035);padding:8px 6px;text-align:center;color:rgba(255,255,255,.76);font:500 11px/1.15 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-flow-step b{display:block;margin-bottom:3px;color:#d8be69;font:600 10px/1 Paralucent,Arial,sans-serif;letter-spacing:.08em}" +
      ".basedai-preunlock-badge{position:fixed;z-index:2147483000;pointer-events:none;box-sizing:border-box;border:1px solid rgba(216,190,105,.4);border-radius:8px;background:rgba(12,12,12,.72);backdrop-filter:blur(12px);padding:10px;color:#fff;font-family:Paralucent,Arial,sans-serif;text-align:left;box-shadow:0 14px 34px rgba(0,0,0,.36);transform:translateZ(0)}" +
      ".basedai-preunlock-badge__eyebrow{margin:0 0 4px;color:#d8be69;font:600 10px/1.1 Paralucent,Arial,sans-serif;letter-spacing:.09em;text-transform:uppercase}" +
      ".basedai-preunlock-badge__title{margin:0;color:#fff;font:600 18px/1.08 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-preunlock-badge__body{margin:5px 0 0;color:rgba(255,255,255,.72);font:400 12px/1.28 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-unlock-perks{position:fixed;z-index:2147483000;pointer-events:none;box-sizing:border-box;margin:0;display:flex;flex-wrap:wrap;justify-content:center;gap:6px;font-family:Paralucent,Arial,sans-serif;transform:translateZ(0)}" +
      ".basedai-unlock-perk{display:inline-flex;align-items:center;gap:6px;border:1px solid rgba(255,255,255,.11);border-radius:999px;background:rgba(255,255,255,.035);padding:6px 9px;color:rgba(255,255,255,.74);font:500 11px/1 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-unlock-perk:before{content:\"\";width:5px;height:5px;border-radius:999px;background:#d8be69;box-shadow:0 0 10px rgba(216,190,105,.65)}" +
      ".basedai-preunlock-host{position:relative!important;isolation:isolate!important}" +
      ".basedai-preunlock-host--fallback:before{content:\"\";position:absolute;left:10px;right:10px;bottom:10px;height:124px;z-index:20;pointer-events:none;box-sizing:border-box;border:1px solid rgba(216,190,105,.4);border-radius:8px;background:rgba(12,12,12,.76);backdrop-filter:blur(12px);box-shadow:0 14px 34px rgba(0,0,0,.36)}" +
      ".basedai-preunlock-host--fallback:after{content:\"REVEAL READY\\A\" attr(data-basedai-preunlock-title) \"\\A Unlock the unblurred result plus the routine that makes it wearable.\\A\" attr(data-basedai-preunlock-meta);white-space:pre-line;position:absolute;left:22px;right:22px;bottom:22px;z-index:21;pointer-events:none;color:#fff;font:600 15px/1.16 Paralucent,Arial,sans-serif;text-align:left;letter-spacing:0}" +
      ".basedai-loading-upgrade{box-sizing:border-box;width:min(420px,calc(100vw - 28px));margin:18px auto 0;color:#fff;font-family:Paralucent,Arial,sans-serif;text-align:center}" +
      ".basedai-loading-upgrade__eyebrow{margin:0 0 7px;color:#d8be69;font:600 11px/1.2 Paralucent,Arial,sans-serif;letter-spacing:.09em;text-transform:uppercase}" +
      ".basedai-loading-upgrade__title{margin:0;color:#fff;font:600 20px/1.12 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-loading-upgrade__body{margin:8px 0 0;color:rgba(255,255,255,.7);font:400 13px/1.35 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-loading-upgrade__phrase-wrap{position:relative;display:flex;align-items:center;justify-content:center;margin:0 auto;color:rgba(255,255,255,.94);font-family:'VCR OSD Mono','OCR A Extended','Share Tech Mono','VT323','IBM Plex Mono','Lucida Console','Consolas','Courier New',monospace;font-size:16px;font-weight:400;line-height:1.12;font-synthesis:none;letter-spacing:.03em;min-height:56px;overflow:hidden;text-transform:uppercase;text-shadow:0 0 2px rgba(255,243,207,.75),1px 0 0 rgba(216,190,105,.24),-1px 0 0 rgba(255,255,255,.08),0 0 14px rgba(216,190,105,.34),0 10px 26px rgba(0,0,0,.45)}" +
      ".basedai-loading-upgrade__phrase-wrap:after{content:\"\";position:absolute;left:8%;right:8%;bottom:4px;height:2px;border-radius:999px;background:linear-gradient(90deg,rgba(216,190,105,0),rgba(255,243,207,.9),rgba(216,190,105,0));opacity:.7;transform-origin:center;animation:basedaiPhraseBeam 1.8s ease-in-out infinite}" +
      ".basedai-loading-upgrade__phrase{display:block;min-width:0;max-width:100%;letter-spacing:.035em;background:linear-gradient(90deg,#ffffff 0%,#fff3cf 45%,#d8be69 100%);-webkit-background-clip:text;background-clip:text;color:transparent;will-change:transform,opacity,filter}" +
      ".basedai-loading-upgrade__phrase--slide{animation:basedaiPhraseSlide 1.65s cubic-bezier(.18,.76,.24,1) both}" +
      ".basedai-loading-upgrade__sms{margin:9px auto 0;color:rgba(255,255,255,.62);font:400 11px/1.35 Paralucent,Arial,sans-serif;letter-spacing:0;text-align:center}" +
      ".basedai-loading-upgrade__sms strong{color:#d8be69;font-weight:600;letter-spacing:.04em}" +
      ".basedai-loading-upgrade__sms-disclosure{width:min(350px,calc(100vw - 40px));margin:7px auto 0;color:rgba(255,255,255,.7);font:400 11px/1.4 Paralucent,Arial,sans-serif;letter-spacing:0;text-align:center}" +
      ".basedai-loading-upgrade__sms-disclosure a{color:#d8be69;text-decoration:underline;text-underline-offset:2px}" +
      "@keyframes basedaiPhraseBeam{0%,100%{opacity:.28;transform:scaleX(.38)}50%{opacity:.82;transform:scaleX(1)}}" +
      "@keyframes basedaiPhraseSlide{0%{opacity:0;filter:blur(5px);transform:translateX(72px) skewX(-8deg)}18%,70%{opacity:1;filter:blur(0);transform:translateX(0) skewX(0)}100%{opacity:0;filter:blur(4px);transform:translateX(-72px) skewX(8deg)}}" +
      ".basedai-loading-upgrade--error{width:min(360px,calc(100vw - 48px));border:1px solid rgba(248,113,113,.45);border-radius:8px;background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.018));padding:14px 16px;text-align:left;box-shadow:0 18px 48px rgba(0,0,0,.3),0 0 0 1px rgba(248,113,113,.08)}" +
      ".basedai-generation-error__button{display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;margin-top:14px;border:0;border-radius:8px;background:linear-gradient(90deg,#c8ac56,#9c8539);color:#111;font:600 14px/1 Paralucent,Arial,sans-serif;letter-spacing:.02em;cursor:pointer}" +
      ".basedai-generation-error__note{margin:10px 0 0;color:rgba(255,255,255,.52);font:400 11px/1.3 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-result-offer{box-sizing:border-box;width:min(344px,calc(100vw - 48px));margin:18px auto 0;border:1px solid rgba(255,255,255,.12);border-radius:8px;background:rgba(255,255,255,.026);color:#fff;font-family:Paralucent,Arial,sans-serif;text-align:left;opacity:.78;transition:opacity .18s ease,border-color .18s ease;background .18s ease}" +
      ".basedai-result-offer[open]{opacity:1;border-color:rgba(200,172,86,.34);background:linear-gradient(180deg,rgba(255,255,255,.052),rgba(255,255,255,.018));box-shadow:0 14px 36px rgba(0,0,0,.24)}" +
      ".basedai-result-offer__summary{box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;gap:10px;min-height:44px;padding:12px 14px;list-style:none;cursor:pointer;color:rgba(255,255,255,.74);font:500 13px/1.2 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-result-offer__summary::-webkit-details-marker{display:none}" +
      ".basedai-result-offer__chevron{width:8px;height:8px;border-right:1.5px solid #d8be69;border-bottom:1.5px solid #d8be69;transform:rotate(45deg);transition:transform .18s ease;flex:0 0 auto;margin-top:-3px}" +
      ".basedai-result-offer[open] .basedai-result-offer__chevron{transform:rotate(225deg);margin-top:3px}" +
      ".basedai-result-offer__box{display:grid;grid-template-columns:64px minmax(0,1fr);gap:12px;align-items:center;border-top:1px solid rgba(255,255,255,.1);padding:13px 14px 14px}" +
      ".basedai-result-offer__image{width:64px;height:64px;border-radius:8px;border:1px solid rgba(216,190,105,.22);background:#101010;object-fit:cover}" +
      ".basedai-result-offer__eyebrow{margin:0 0 4px;color:#d8be69;font:600 10px/1.1 Paralucent,Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase}" +
      ".basedai-result-offer__title{margin:0;color:#fff;font:600 16px/1.16 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-result-offer__body{margin:5px 0 0;color:rgba(255,255,255,.64);font:400 12px/1.3 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-result-offer__contains{margin:7px 0 0;color:rgba(255,255,255,.52);font:400 11px/1.25 Paralucent,Arial,sans-serif;letter-spacing:0}" +
      ".basedai-result-offer__actions{grid-column:1/-1;display:grid;grid-template-columns:1fr;gap:8px;margin-top:2px}" +
      ".basedai-result-offer__button{display:flex;align-items:center;justify-content:center;min-height:42px;border-radius:8px;text-decoration:none;font:600 13px/1 Paralucent,Arial,sans-serif;letter-spacing:.01em}" +
      ".basedai-result-offer__button--primary{background:linear-gradient(90deg,#c8ac56,#9c8539);color:#111}" +
      ".basedai-result-save-note{box-sizing:border-box;width:min(344px,calc(100vw - 48px));margin:13px auto 0;color:rgba(255,255,255,.52);font:400 11px/1.35 Paralucent,Arial,sans-serif;letter-spacing:0;text-align:center}" +
      ".basedai-result-save-note strong{color:rgba(216,190,105,.88);font-weight:600}" +
      ".basedai-result-save-note a{color:#d8be69;text-decoration:underline;text-underline-offset:2px}" +
      ".basedai-return-home{display:block;width:max-content;max-width:calc(100vw - 48px);margin:16px auto 0;color:rgba(255,255,255,.48);font:500 13px/1.2 Paralucent,Arial,sans-serif;letter-spacing:0;text-align:center;text-decoration:underline;text-underline-offset:3px}" +
      ".basedai-return-home:hover{color:rgba(255,255,255,.7)}" +
      ".basedai-managed-scroll{box-sizing:border-box!important;width:100%!important;max-width:100%!important;height:100%!important;min-height:100%!important;overflow-y:auto!important;overflow-x:hidden!important;overscroll-behavior-y:contain!important;overscroll-behavior-x:none!important;overflow-anchor:none!important;-webkit-overflow-scrolling:touch!important;scroll-behavior:auto!important;scrollbar-width:auto!important;scrollbar-gutter:auto!important;scroll-padding-top:0!important;scroll-padding-bottom:max(132px,calc(108px + env(safe-area-inset-bottom)))!important}" +
      ".basedai-managed-shell{box-sizing:border-box!important;width:100%!important;max-width:520px!important;height:auto!important;min-height:100%!important;justify-content:flex-start!important;margin-top:0!important;padding-left:24px!important;padding-right:24px!important;padding-top:clamp(28px,4dvh,56px)!important;padding-bottom:max(104px,calc(84px + env(safe-area-inset-bottom)))!important;overflow-x:hidden!important;overflow-anchor:none!important}" +
      ".basedai-managed-shell>div:first-child{margin-top:0!important}" +
      ".basedai-managed-shell h1,.basedai-managed-shell h2{line-height:1.16!important;letter-spacing:0!important;overflow:visible!important;padding-top:2px!important}" +
      ".basedai-managed-shell--pick{padding-top:clamp(22px,3.2dvh,34px)!important;padding-bottom:max(132px,calc(110px + env(safe-area-inset-bottom)))!important}" +
      ".basedai-managed-shell--pick>h2{display:none!important}" +
      ".basedai-managed-shell--pick>p:first-of-type{margin:0 0 8px!important;color:#fff!important;font:500 clamp(22px,6.4vw,26px)/1.08 Paralucent,Arial,sans-serif!important;letter-spacing:0!important;text-align:center!important}" +
      ".basedai-managed-shell--pick>div{margin-top:4px!important}" +
      ".basedai-managed-shell--pick>button{margin-top:18px!important}" +
      ".basedai-managed-shell--pick>button+button{margin-top:10px!important}" +
      ".basedai-managed-shell--upload{padding-top:clamp(18px,2.7dvh,30px)!important;padding-bottom:max(142px,calc(118px + env(safe-area-inset-bottom)))!important}" +
      ".basedai-managed-shell--upload h1{font-size:clamp(21px,5.8vw,25px)!important;line-height:1.04!important;padding-top:0!important}" +
      ".basedai-managed-shell--upload img[data-basedai-brand-logo]{width:min(222px,58vw)!important;height:auto!important;margin-top:0!important}" +
      ".basedai-managed-shell--upload>div:nth-child(2)>div{aspect-ratio:296/395;width:min(286px,calc(100vw - 68px),calc(43.5dvh * .749))!important;height:auto!important;margin-top:clamp(12px,2dvh,18px)!important}" +
      ".basedai-managed-shell--upload>div:nth-child(2)>p{margin-top:6px!important;font-size:clamp(14px,3.8vw,16px)!important;line-height:1.16!important}" +
      ".basedai-managed-shell--upload .basedai-photo-consent-note{width:min(342px,calc(100vw - 40px))!important;margin-top:12px!important;gap:8px!important;font-size:10.5px!important;line-height:1.22!important}" +
      ".basedai-managed-shell--upload .basedai-photo-consent-error{width:min(342px,calc(100vw - 40px))!important;margin-top:4px!important}" +
      ".basedai-managed-shell--upload .basedai-photo-consent-note+button,.basedai-managed-shell--upload .basedai-photo-consent-error+button{margin-top:12px!important}" +
      ".basedai-managed-shell--upload .basedai-flow-strip{width:min(342px,calc(100vw - 40px))!important;margin-top:10px!important}" +
      ".basedai-managed-shell--loading{justify-content:center!important;padding-top:32px!important;padding-bottom:32px!important;overflow:hidden!important}" +
      ".basedai-managed-shell--loading img[data-basedai-brand-logo]{width:min(128px,34vw)!important;height:auto!important;opacity:.86!important;margin-top:12px!important}" +
      ".basedai-managed-shell--preunlock{padding-top:clamp(20px,3dvh,34px)!important;padding-bottom:calc(24px + env(safe-area-inset-bottom))!important}" +
      ".basedai-managed-shell--preunlock h1{font-size:clamp(22px,6vw,26px)!important;line-height:1.08!important}" +
      ".basedai-managed-shell--preunlock img[alt=\"Ready\"]{width:min(156px,42vw)!important;height:auto!important}" +
      ".basedai-managed-shell--preunlock>div:nth-child(2)>div{aspect-ratio:296/395;width:min(266px,calc(100vw - 86px),calc(35dvh * .749))!important;height:auto!important;margin-top:clamp(14px,2dvh,20px)!important}" +
      ".basedai-managed-shell--preunlock .basedai-preunlock-badge{padding:10px!important}" +
      ".basedai-managed-shell--preunlock .basedai-preunlock-badge__eyebrow{margin-bottom:3px!important;font-size:9.5px!important}" +
      ".basedai-managed-shell--preunlock .basedai-preunlock-badge__title{font-size:16px!important;line-height:1.08!important}" +
      ".basedai-managed-shell--preunlock .basedai-preunlock-badge__body{margin-top:4px!important;font-size:11px!important;line-height:1.22!important}" +
      ".basedai-managed-shell--preunlock>div:nth-child(3){margin-top:42px!important}" +
      ".basedai-managed-shell--preunlock .basedai-unlock-perks{margin-bottom:8px!important;gap:5px!important}" +
      ".basedai-managed-shell--preunlock .basedai-unlock-perk{padding:5px 8px!important;font-size:10.5px!important}" +
      ".basedai-managed-shell--preunlock input[type=\"email\"]{height:44px!important;font-size:15px!important}" +
      ".basedai-managed-shell--preunlock .basedai-email-consent-note{width:min(344px,calc(100vw - 40px))!important;margin-top:8px!important;font-size:10.5px!important;line-height:1.2!important}" +
      ".basedai-managed-shell--preunlock button{min-height:0!important;height:46px!important;margin-top:10px!important}" +
      ".basedai-managed-shell--result{padding-top:clamp(18px,2.6dvh,34px)!important;padding-bottom:max(126px,calc(104px + env(safe-area-inset-bottom)))!important}" +
      ".basedai-managed-shell--result img[alt=\"Your Tailored\"]{width:min(246px,66vw)!important;height:auto!important}" +
      ".basedai-managed-shell--result>div:nth-child(2)>div{margin-top:clamp(12px,2dvh,20px)!important}" +
      ".basedai-managed-shell--result>div:nth-child(3){margin-top:18px!important}" +
      ".basedai-result-scroll-shell{justify-content:flex-start!important;height:auto!important;min-height:100%!important;overflow-x:hidden!important;overflow-anchor:none!important;padding-top:clamp(18px,2.6dvh,34px)!important;padding-bottom:max(148px,calc(124px + env(safe-area-inset-bottom)))!important;scrollbar-width:auto!important;scrollbar-gutter:auto!important}" +
      ".basedai-result-action-block{padding-bottom:0!important;margin-bottom:0!important}" +
      "@media(max-width:420px){.basedai-loading-upgrade__phrase-wrap{font-size:14px;min-height:52px;letter-spacing:.022em}.basedai-loading-upgrade__phrase{letter-spacing:.022em}.basedai-loading-upgrade{width:min(340px,calc(100vw - 28px));margin-top:16px}.basedai-loading-upgrade__sms{width:min(300px,calc(100vw - 48px));font-size:10.5px}.basedai-loading-upgrade__sms-disclosure{width:min(330px,calc(100vw - 32px));font-size:11px}.basedai-result-save-note{width:min(344px,calc(100vw - 40px));margin-top:11px}}";
    document.head.appendChild(style);
  }

  function normalizeText(node) {
    return String((node && node.textContent) || "").replace(/\s+/g, " ").trim();
  }

  function escapeHtml(value) {
    var chars = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return chars[char];
    });
  }

  function assetPath(path) {
    try {
      return new URL(path, (scriptEl && scriptEl.src) || window.location.href).toString();
    } catch (_) {
      return "/assets/" + path;
    }
  }

  function resolveWidgetAsset(path) {
    var value = String(path || "");
    if (!value) return value;
    if (/^(?:https?:|data:|blob:|\/\/)/i.test(value)) return value;
    return assetPath(value.replace(/^\/assets\//, "").replace(/^\.\//, ""));
  }

  function installWidgetAssetResolver() {
    window.__resolveAsset = resolveWidgetAsset;
  }

  function findBrandLogo(widget) {
    return (
      widget.querySelector("img[data-basedai-brand-logo]") ||
      widget.querySelector('img[alt="BASED AI"]') ||
      widget.querySelector('img[alt="Based Hair IQ"]')
    );
  }

  function replaceBranding() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;

    Array.prototype.slice.call(widget.querySelectorAll('img[alt="BASED AI"], img[alt="Based Hair IQ"]')).forEach(function (img) {
      img.setAttribute("alt", "Based");
      img.setAttribute("data-basedai-brand-logo", "true");
      img.src = assetPath("logo__based-vector.png");
      img.style.width = "min(234px, 62vw)";
      img.style.height = "auto";
    });

    var walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      node.nodeValue = String(node.nodeValue || "")
        .replace(/Based AI/g, "Hair IQ")
        .replace(/BASED AI/g, "HAIR IQ")
        .replace(/Pick the look you want to try\./g, "Pick the look you want to try");
    });
  }

  function replaceStylePickerAssets() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;
    Array.prototype.slice.call(widget.querySelectorAll("img[alt]")).forEach(function (img) {
      var asset = STYLE_PICKER_ASSETS[img.getAttribute("alt")];
      if (!asset) return;
      var nextSrc = assetPath(asset);
      if (img.getAttribute("data-basedai-picker-asset") === nextSrc) return;
      img.src = nextSrc;
      img.setAttribute("data-basedai-picker-asset", nextSrc);
    });
  }

  function setLoadingPhrase(node) {
    if (!node || !LOADING_PHRASES.length) return;
    node.classList.remove("basedai-loading-upgrade__phrase--slide");
    node.textContent = LOADING_PHRASES[loadingPhraseIndex % LOADING_PHRASES.length];
    void node.offsetWidth;
    node.classList.add("basedai-loading-upgrade__phrase--slide");
    loadingPhraseIndex += 1;
  }

  function startLoadingPhraseRotation(panel) {
    var phrase = panel && panel.querySelector("#basedai-loading-phrase");
    if (!phrase) {
      stopLoadingPhraseRotation();
      return;
    }
    if (!phrase.textContent) setLoadingPhrase(phrase);
    if (loadingPhraseTimer) return;
    loadingPhraseTimer = window.setInterval(function () {
      var activePhrase = document.querySelector("#basedai-loading-phrase");
      if (!activePhrase) {
        stopLoadingPhraseRotation();
        return;
      }
      setLoadingPhrase(activePhrase);
    }, 1800);
  }

  function stopLoadingPhraseRotation() {
    if (!loadingPhraseTimer) return;
    window.clearInterval(loadingPhraseTimer);
    loadingPhraseTimer = null;
  }

  function isWidgetAction(button, pattern) {
    return (
      button &&
      button.closest &&
      button.closest(".basedai-widget") &&
      pattern.test(normalizeText(button))
    );
  }

  function installActionConsentListeners() {
    if (window.__BasedAIPrivacyActionConsentInstalled) return;
    window.__BasedAIPrivacyActionConsentInstalled = true;

    document.addEventListener(
      "click",
      function (event) {
        var button = event.target && event.target.closest ? event.target.closest("button") : null;
        var returnHome = event.target && event.target.closest ? event.target.closest("#basedai-return-home") : null;
        if (returnHome && returnHome.closest && returnHome.closest(".basedai-widget")) {
          trackReturnHomeClick(readResultLabel() || readPendingLabel());
        }
        if (isWidgetAction(button, /^(TAKE SELFIE|UPLOAD SELFIE(?:\s*→)?|UPLOAD FROM LIBRARY)$/i)) {
          if (!requirePhotoConsentClickwrap(event)) return;
          if (shouldUseNativeSelfieFallback(button)) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
            triggerNativeSelfieFallback(button);
            return;
          }
        }
        if (isWidgetAction(button, /UNLOCK YOUR LOOK/i)) {
          grantEmailConsent();
        }
        if (isWidgetAction(button, /^TRY ANOTHER STYLE$/i)) {
          trackTryAnotherClick(readResultLabel() || readPendingLabel());
        }
        if (isWidgetAction(button, /^Restart and try again$/i)) {
          trackGenerationRestartClick();
        }
      },
      true
    );

    ["input", "change"].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function (event) {
          var target = event.target;
          if (!target || !target.classList || !target.classList.contains("basedai-photo-consent-checkbox")) return;
          applyPhotoConsentCheckboxState(target);
        },
        true
      );
    });

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (form && form.querySelector && form.closest(".basedai-widget") && form.querySelector('input[type="email"]')) {
          grantEmailConsent();
        }
      },
      true
    );
  }

  function insertAfter(referenceNode, node) {
    if (!referenceNode || !referenceNode.parentNode) return;
    referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
  }

  function classText(node) {
    return String((node && node.className) || "");
  }

  function findStepShell(node) {
    var current = node;
    while (current && current.nodeType === 1 && !current.classList.contains("basedai-widget")) {
      var classes = classText(current);
      if (classes.indexOf("max-w-[520px]") !== -1 && classes.indexOf("flex-col") !== -1) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  function findScrollContainer(shell, widget) {
    var current = shell;
    while (current && current !== widget) {
      if (classText(current).indexOf("overflow-y-auto") !== -1) return current;
      current = current.parentElement;
    }
    return shell;
  }

  function findLockedPreviewImage(widget) {
    if (!widget || !widget.querySelector) return null;
    var exact = widget.querySelector(
      'img[alt="Locked preview (blurred)"], img[data-uw-rm-alt-original="Locked preview (blurred)"]'
    );
    if (exact) return exact;

    var images = Array.prototype.slice.call(widget.querySelectorAll("img"));
    return images.find(function (image) {
      var src = image.getAttribute("src") || "";
      var classes = classText(image);
      var inlineStyle = (image.getAttribute("style") || "") + ";" + ((image.style && image.style.filter) || "");
      return (
        src.indexOf("blob:") === 0 &&
        classes.indexOf("object-cover") !== -1 &&
        /blur\s*\(/i.test(inlineStyle)
      );
    }) || null;
  }

  function findPreUnlockState(widget) {
    if (!widget || !widget.querySelector) return null;
    var lockedImage = findLockedPreviewImage(widget);
    var input = widget.querySelector('input[type="email"]');
    if (!lockedImage || !input) return null;

    var shell = findStepShell(lockedImage) || findStepShell(input);
    if (!shell) {
      shell = lockedImage.parentElement;
      while (shell && shell.parentElement && shell.parentElement !== widget) {
        shell = shell.parentElement;
      }
    }

    return {
      input: input,
      lockedImage: lockedImage,
      shell: shell
    };
  }

  function resetWidgetScroll(widget, scrollContainer) {
    var activeScrollContainer = scrollContainer;
    if (!activeScrollContainer && widget && widget.querySelector) {
      activeScrollContainer = widget.querySelector(".basedai-managed-scroll");
    }
    if (!activeScrollContainer) return;
    try {
      activeScrollContainer.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch (_) {
      activeScrollContainer.scrollTop = 0;
      activeScrollContainer.scrollLeft = 0;
    }
  }

  function scheduleWidgetScrollReset(widget, shell) {
    if (!widget || !shell) return;
    if (widget.__basedAiScrollResetFrame) {
      window.cancelAnimationFrame(widget.__basedAiScrollResetFrame);
    }
    widget.__basedAiScrollResetFrame = window.requestAnimationFrame(function () {
      widget.__basedAiScrollResetFrame = 0;
      resetWidgetScroll(widget, findScrollContainer(shell, widget));
    });
  }

  function clearManagedLayoutState(widget) {
    if (!widget) return;
    widget.removeAttribute("data-basedai-layout-state");
    Array.prototype.slice.call(widget.querySelectorAll(".basedai-managed-shell")).forEach(function (node) {
      node.classList.remove(
        "basedai-managed-shell",
        "basedai-managed-shell--pick",
        "basedai-managed-shell--upload",
        "basedai-managed-shell--loading",
        "basedai-managed-shell--preunlock",
        "basedai-managed-shell--result"
      );
    });
    Array.prototype.slice.call(widget.querySelectorAll(".basedai-managed-scroll")).forEach(function (node) {
      node.classList.remove("basedai-managed-scroll");
    });
    if (widget.__basedAiScrollResetFrame) {
      window.cancelAnimationFrame(widget.__basedAiScrollResetFrame);
      widget.__basedAiScrollResetFrame = 0;
    }
    widget.__basedAiScrollOwner = null;
  }

  function applyManagedLayoutState(widget, state, shell) {
    if (!widget || !state || !shell) {
      clearManagedLayoutState(widget);
      return;
    }

    var previous = widget.getAttribute("data-basedai-layout-state");
    Array.prototype.slice.call(widget.querySelectorAll(".basedai-managed-shell")).forEach(function (node) {
      node.classList.remove(
        "basedai-managed-shell",
        "basedai-managed-shell--pick",
        "basedai-managed-shell--upload",
        "basedai-managed-shell--loading",
        "basedai-managed-shell--preunlock",
        "basedai-managed-shell--result"
      );
    });
    Array.prototype.slice.call(widget.querySelectorAll(".basedai-managed-scroll")).forEach(function (node) {
      node.classList.remove("basedai-managed-scroll");
    });

    shell.classList.add("basedai-managed-shell", "basedai-managed-shell--" + state);
    var scrollContainer = findScrollContainer(shell, widget);
    if (scrollContainer) scrollContainer.classList.add("basedai-managed-scroll");
    widget.setAttribute("data-basedai-layout-state", state);

    if (previous !== state || widget.__basedAiScrollOwner !== scrollContainer) {
      widget.__basedAiScrollOwner = scrollContainer;
      scheduleWidgetScrollReset(widget, shell);
    }
  }

  function neutralizeInertBackdrop(widget) {
    if (!widget || !widget.querySelector) return;
    var backdrop = widget.querySelector('button[aria-label="Close"]');
    if (!backdrop) return;
    backdrop.setAttribute("aria-hidden", "true");
    backdrop.setAttribute("tabindex", "-1");
  }

  function syncManagedLayoutState() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;
    neutralizeInertBackdrop(widget);

    var buttons = Array.prototype.slice.call(widget.querySelectorAll("button"));
    var tryAnother = buttons.find(function (button) {
      return /^TRY ANOTHER STYLE$/i.test(normalizeText(button));
    });
    if (tryAnother) {
      var actionBlock = tryAnother.parentElement && tryAnother.parentElement.parentElement;
      applyManagedLayoutState(widget, "result", actionBlock && actionBlock.parentElement);
      return;
    }

    var preUnlockState = findPreUnlockState(widget);
    if (preUnlockState) {
      applyManagedLayoutState(widget, "preunlock", preUnlockState.shell);
      return;
    }

    var loadingPanel = widget.querySelector("#basedai-loading-upgrade");
    if (loadingPanel) {
      applyManagedLayoutState(widget, "loading", findStepShell(loadingPanel));
      return;
    }

    var continueButton = buttons.find(function (button) {
      return /^CONTINUE$/i.test(normalizeText(button));
    });
    if (continueButton) {
      var widgetText = normalizeText(widget);
      var isPickStep = /PICK STYLE|PICK COLOR|PICK TYPE|Pick the look you want to try/i.test(widgetText);
      applyManagedLayoutState(widget, isPickStep ? "pick" : "upload", findStepShell(continueButton));
      return;
    }

    var photoButton = buttons.find(function (button) {
      return /^(TAKE SELFIE|UPLOAD SELFIE(?:\s*→)?|UPLOAD FROM LIBRARY)$/i.test(normalizeText(button));
    });
    if (photoButton) {
      applyManagedLayoutState(widget, "upload", findStepShell(photoButton));
      return;
    }

    if (widget.getAttribute("data-basedai-layout-state") === "preunlock" && preUnlockRemovalTimer) return;

    clearManagedLayoutState(widget);
  }

  function renderInlineConsentNotes() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;

    var buttons = Array.prototype.slice.call(widget.querySelectorAll("button"));
    var photoButton = buttons.find(function (button) {
      return /^(TAKE SELFIE|UPLOAD SELFIE(?:\s*→)?|UPLOAD FROM LIBRARY)$/i.test(normalizeText(button));
    });
    if (photoButton) {
      var panel = photoButton.parentElement;
      while (panel && panel.parentElement && !/w-full/.test(panel.className || "")) {
        panel = panel.parentElement;
      }
      if (panel) {
        var flowStrip = panel.querySelector(".basedai-photo-flow-strip");
        var photoNote = panel.querySelector(".basedai-photo-consent-note");
        if (!photoNote) {
          photoNote = document.createElement("label");
          photoNote.className = "basedai-photo-consent-note";
          photoNote.innerHTML =
            '<input class="basedai-photo-consent-checkbox" type="checkbox" />' +
            '<span>By submitting a photo or using Hair IQ, you affirm that you are at least 18 years old, accept our <a href="' + TERMS_URL + '" target="_blank" rel="noreferrer">Terms of Service</a> and <a href="' + PRIVACY_URL + '" target="_blank" rel="noreferrer">Privacy Policy</a>, and consent to AI processing of your photo to generate hairstyle results.</span>';
        }
        var photoError = panel.querySelector(".basedai-photo-consent-error");
        if (!photoError) {
          photoError = document.createElement("p");
          photoError.className = "basedai-photo-consent-error";
          photoError.hidden = true;
        }
        if (photoError.parentNode !== panel || photoError.nextElementSibling !== photoButton) {
          if (photoButton.parentNode === panel) {
            panel.insertBefore(photoError, photoButton);
          } else {
            panel.appendChild(photoError);
          }
        }
        if (photoNote.parentNode !== panel || photoNote.nextElementSibling !== photoError) {
          if (photoError.parentNode === panel) {
            panel.insertBefore(photoNote, photoError);
          } else {
            panel.appendChild(photoNote);
          }
        }
        if (!flowStrip) {
          flowStrip = document.createElement("div");
          flowStrip.className = "basedai-flow-strip basedai-photo-flow-strip";
          flowStrip.innerHTML =
            '<span class="basedai-flow-step"><b>01</b>Try a cut</span>' +
            '<span class="basedai-flow-step"><b>02</b>Unlock result</span>' +
            '<span class="basedai-flow-step"><b>03</b>Shop the look</span>';
        }
        if (flowStrip.parentNode !== panel) {
          panel.appendChild(flowStrip);
        }
      }
      syncPhotoConsentState(widget);
    }

    Array.prototype.slice.call(widget.querySelectorAll('input[type="email"]')).forEach(function (input) {
      var next = input.nextElementSibling;
      if (next && next.classList && next.classList.contains("basedai-email-consent-note")) return;
      var emailNote = document.createElement("p");
      emailNote.className = "basedai-inline-consent-note basedai-email-consent-note";
      emailNote.innerHTML =
        'By entering your email, you agree to retrieve this generated result and receive Hair IQ messages. See <a href="' + TERMS_URL + '" target="_blank" rel="noreferrer">Terms</a> and <a href="' + PRIVACY_URL + '" target="_blank" rel="noreferrer">Privacy Policy</a>. You can unsubscribe anytime.';
      insertAfter(input, emailNote);
    });
  }

  function slug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function withUtm(url, params) {
    try {
      var u = new URL(url);
      Object.keys(params).forEach(function (key) {
        u.searchParams.set(key, params[key]);
      });
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  function attributionCookieDomain() {
    try {
      var host = window.location.hostname || "";
      if (host === "based.com" || /\.based\.com$/i.test(host)) return "; Domain=.based.com";
    } catch (_) {}
    return "";
  }

  function writeHairIqAttribution(payload) {
    try {
      var expiresAt = new Date(Date.now() + HAIR_IQ_ATTRIBUTION_MAX_AGE_SECONDS * 1000).toISOString();
      var stored = sanitizeAnalyticsPayload(Object.assign({}, payload || {}, {
        saved_at: nowIso(),
        expires_at: expiresAt
      }));
      var json = JSON.stringify(stored);
      try {
        window.sessionStorage.setItem(HAIR_IQ_ATTRIBUTION_KEY, json);
      } catch (_) {}
      try {
        document.cookie =
          HAIR_IQ_ATTRIBUTION_KEY + "=" + encodeURIComponent(json) +
          "; Max-Age=" + HAIR_IQ_ATTRIBUTION_MAX_AGE_SECONDS +
          "; Path=/; SameSite=Lax" +
          (window.location.protocol === "https:" ? "; Secure" : "") +
          attributionCookieDomain();
      } catch (_) {}
      return stored;
    } catch (_) {
      return null;
    }
  }

  function readResultLabel() {
    return readStorageValue("basedai_label");
  }

  function readPendingLabel() {
    return readStorageValue("basedai_pending_label") || readResultLabel();
  }

  function readStorageValue(key) {
    try {
      return window.sessionStorage.getItem(key) || window.localStorage.getItem(key) || "";
    } catch (_) {
      return "";
    }
  }

  function readSelectedTypeId(label) {
    var stored = readStorageValue("basedai_typeId");
    if (stored) return stored;
    var text = String(label || "").toLowerCase();
    if (/\bcoily\b/.test(text)) return "coily";
    if (/\bcurly\b/.test(text)) return "curly";
    if (/\bwavy\b/.test(text)) return "wavy";
    if (/\bstraight\b/.test(text)) return "straight";
    return "straight";
  }

  function readSelectedStyleId(label) {
    var stored = readStorageValue("basedai_styleId");
    if (stored) return stored;
    var text = String(label || "").toLowerCase();
    if (/\bbuzz\b/.test(text)) return "buzz";
    if (/\bfade\b/.test(text)) return "fade";
    if (/\bmullet\b/.test(text)) return "mullet";
    if (/\bmiddle\s+part\b/.test(text)) return "middle-part";
    if (/\bside\s+part\b/.test(text)) return "side-part";
    return "";
  }

  function displayHairType(typeId) {
    var stored = readStorageValue("basedai_typeLabel");
    if (stored) return stored.toLowerCase();
    return String(typeId || "straight");
  }

  function withSelectionCopy(set, label) {
    var typeId = readSelectedTypeId(label);
    var styleId = readSelectedStyleId(label);
    var typeLabel = displayHairType(typeId);
    var copy = Object.assign(
      {
        offerTitle: "Get the set for this hair type"
      },
      set
    );

    if (styleId === "buzz") {
      copy.bestFor = "All hair types and lengths";
      copy.offerTitle = "Start with a better wash routine";
      copy.eyebrow = "Hair + scalp care";
      copy.line =
        "A simple wash-and-condition routine for a cleaner, healthier-looking buzz cut and scalp without unnecessary styling product.";
    } else if (styleId === "fade") {
      copy.bestFor = "Short " + typeLabel + " hair";
      copy.offerTitle = "Keep this short cut looking intentional";
      if (typeId === "curly" || typeId === "coily") {
        copy.eyebrow = "Volume + hold";
        copy.line =
          "A two-step curl styling set for " +
          typeLabel +
          " fades with enough length on top to need volume, definition, and lasting hold.";
      } else {
        copy.eyebrow = "Matte texture";
        copy.line =
          "A matte styling set for short " +
          typeLabel +
          " cuts that need lift, separation, and flexible hold without shine.";
      }
    }

    return copy;
  }

  function pickSetRecommendation(label) {
    var typeId = readSelectedTypeId(label);
    var styleId = readSelectedStyleId(label);
    var styleMatrix = HAIRSTYLE_SET_MATRIX[styleId] || {};
    var setKey = styleMatrix[typeId] || HAIR_TYPE_SET_MAP[typeId] || "textureEssentials";
    var set = SET_RECOMMENDATIONS[setKey] || SET_RECOMMENDATIONS.textureEssentials;
    return withSelectionCopy(set, label);
  }

  var preUnlockRepairTimers = [];
  var preUnlockPositionListenersInstalled = false;
  var preUnlockPositionFrame = null;
  var preUnlockRemovalTimer = null;

  function clearPreUnlockRepairTimers() {
    if (!preUnlockRepairTimers.length) return;
    preUnlockRepairTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    preUnlockRepairTimers = [];
  }

  function schedulePreUnlockRepair() {
    if (preUnlockRepairTimers.length) return;

    [80, 240, 600, 1200, 2200, 3600, 5200].forEach(function (delay) {
      var timer = window.setTimeout(function () {
        preUnlockRepairTimers = preUnlockRepairTimers.filter(function (item) {
          return item !== timer;
        });
        if (renderPreUnlockExperience()) {
          syncManagedLayoutState();
        }
      }, delay);
      preUnlockRepairTimers.push(timer);
    });
  }

  function clearPreUnlockRemovalTimer() {
    if (!preUnlockRemovalTimer) return;
    window.clearTimeout(preUnlockRemovalTimer);
    preUnlockRemovalTimer = null;
  }

  function schedulePreUnlockRemoval() {
    if (preUnlockRemovalTimer) return;
    preUnlockRemovalTimer = window.setTimeout(function () {
      preUnlockRemovalTimer = null;
      if (!findPreUnlockState(document.querySelector(".basedai-widget"))) {
        removePreUnlockDecorations();
      }
    }, 700);
  }

  function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function viewportSize() {
    var root = document.documentElement || {};
    return {
      width: window.innerWidth || root.clientWidth || 390,
      height: window.innerHeight || root.clientHeight || 844
    };
  }

  function removePreUnlockFloatingElements() {
    clearPreUnlockRemovalTimer();
    var badge = document.getElementById("basedai-preunlock-badge");
    var perks = document.getElementById("basedai-unlock-perks");
    if (badge) badge.remove();
    if (perks) perks.remove();
  }

  function clearPreUnlockHostDecorations(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll(".basedai-preunlock-host")).forEach(function (host) {
      host.classList.remove(
        "basedai-preunlock-host",
        "basedai-preunlock-host--shadow",
        "basedai-preunlock-host--fallback"
      );
      host.removeAttribute("data-basedai-preunlock-title");
      host.removeAttribute("data-basedai-preunlock-meta");
      if (host.shadowRoot && host.shadowRoot.querySelector("#basedai-preunlock-shadow-style")) {
        host.shadowRoot.innerHTML = "<slot></slot>";
      }
    });
  }

  function removePreUnlockDecorations(scope) {
    removePreUnlockFloatingElements();
    clearPreUnlockHostDecorations(scope);
  }

  function renderPreUnlockHostCard(preUnlockState, title, set) {
    var host = preUnlockState && preUnlockState.lockedImage && preUnlockState.lockedImage.parentElement;
    if (!host) return;

    var meta = "Full image | " + set.eyebrow + " | Save + share";
    host.classList.add("basedai-preunlock-host");
    host.setAttribute("data-basedai-preunlock-title", title);
    host.setAttribute("data-basedai-preunlock-meta", meta);

    var renderedShadow = false;
    try {
      var shadowRoot = host.shadowRoot || (host.attachShadow && host.attachShadow({ mode: "open" }));
      if (shadowRoot) {
        renderedShadow = true;
        host.classList.add("basedai-preunlock-host--shadow");
        host.classList.remove("basedai-preunlock-host--fallback");
        var renderKey = title + "|" + meta;
        var existing = shadowRoot.querySelector("[data-basedai-shadow-card]");
        if (!existing || existing.getAttribute("data-render-key") !== renderKey) {
          shadowRoot.innerHTML =
            '<style id="basedai-preunlock-shadow-style">' +
            ':host{position:relative!important;display:block!important;isolation:isolate!important}' +
            'slot{display:contents}' +
            '.card{position:absolute;left:10px;right:10px;bottom:10px;z-index:20;pointer-events:none;box-sizing:border-box;border:1px solid rgba(216,190,105,.42);border-radius:8px;background:rgba(12,12,12,.78);backdrop-filter:blur(12px);padding:10px 11px;color:#fff;font-family:Paralucent,Arial,sans-serif;text-align:left;box-shadow:0 14px 34px rgba(0,0,0,.36)}' +
            '.eyebrow{margin:0 0 4px;color:#d8be69;font:600 10px/1.1 Paralucent,Arial,sans-serif;letter-spacing:.09em;text-transform:uppercase}' +
            '.title{margin:0;color:#fff;font:600 17px/1.08 Paralucent,Arial,sans-serif;letter-spacing:0}' +
            '.body{margin:5px 0 0;color:rgba(255,255,255,.72);font:400 11.5px/1.24 Paralucent,Arial,sans-serif;letter-spacing:0}' +
            '.meta{margin:7px 0 0;color:rgba(216,190,105,.82);font:600 10px/1.2 Paralucent,Arial,sans-serif;letter-spacing:.02em}' +
            '</style><slot></slot>' +
            '<div class="card" data-basedai-shadow-card data-render-key="' + escapeHtml(renderKey) + '">' +
            '<p class="eyebrow">Reveal ready</p>' +
            '<h2 class="title">' + escapeHtml(title) + '</h2>' +
            '<p class="body">Unlock the unblurred result plus the routine that makes it wearable.</p>' +
            '<p class="meta">' + escapeHtml(meta) + '</p>' +
            '</div>';
        }
      }
    } catch (_) {
      renderedShadow = false;
    }

    if (!renderedShadow) {
      host.classList.add("basedai-preunlock-host--fallback");
      host.classList.remove("basedai-preunlock-host--shadow");
    }
  }

  function positionPreUnlockFloatingElements() {
    preUnlockPositionFrame = null;
    var widget = document.querySelector(".basedai-widget");
    var preUnlockState = findPreUnlockState(widget);
    var lockedImage = preUnlockState && preUnlockState.lockedImage;
    var input = preUnlockState && preUnlockState.input;
    var badge = document.getElementById("basedai-preunlock-badge");
    var perks = document.getElementById("basedai-unlock-perks");
    if (!lockedImage || !badge) return;

    var view = viewportSize();
    var imageShell = lockedImage.parentElement || lockedImage;
    var imageRect = imageShell.getBoundingClientRect();
    var badgeWidth = Math.max(180, Math.min(imageRect.width - 24, view.width - 24));
    var badgeLeft = clampNumber(imageRect.left + (imageRect.width - badgeWidth) / 2, 12, view.width - badgeWidth - 12);
    badge.style.width = Math.round(badgeWidth) + "px";
    badge.style.left = Math.round(badgeLeft) + "px";
    badge.style.top = "0px";

    var badgeHeight = badge.offsetHeight || 96;
    var badgeTop = clampNumber(imageRect.bottom - badgeHeight - 12, 8, view.height - badgeHeight - 8);
    badge.style.top = Math.round(badgeTop) + "px";

    if (!perks || !input) return;
    var inputRect = input.getBoundingClientRect();
    var perksWidth = Math.max(180, Math.min(274, view.width - 24));
    var perksLeft = clampNumber(inputRect.left + (inputRect.width - perksWidth) / 2, 12, view.width - perksWidth - 12);
    perks.style.width = Math.round(perksWidth) + "px";
    perks.style.left = Math.round(perksLeft) + "px";
    perks.style.top = "0px";

    var perksHeight = perks.offsetHeight || 28;
    var perksTop = inputRect.top - perksHeight - 8;
    perksTop = Math.max(imageRect.bottom + 8, perksTop);
    perks.style.top = Math.round(clampNumber(perksTop, 8, view.height - perksHeight - 8)) + "px";
  }

  function schedulePreUnlockPosition() {
    if (preUnlockPositionFrame !== null) return;
    preUnlockPositionFrame = window.requestAnimationFrame(positionPreUnlockFloatingElements);
  }

  function installPreUnlockPositionListeners() {
    if (preUnlockPositionListenersInstalled) return;
    preUnlockPositionListenersInstalled = true;
    window.addEventListener("scroll", schedulePreUnlockPosition, true);
    window.addEventListener("resize", schedulePreUnlockPosition);
    window.addEventListener("orientationchange", schedulePreUnlockPosition);
  }

  function renderPreUnlockExperience() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) {
      removePreUnlockDecorations();
      return false;
    }

    var preUnlockState = findPreUnlockState(widget);
    var input = preUnlockState && preUnlockState.input;

    if (!preUnlockState) {
      schedulePreUnlockRemoval();
      return false;
    }

    clearPreUnlockRemovalTimer();

    var label = readResultLabel() || readPendingLabel();
    var set = pickSetRecommendation(label);
    var title = label ? label + " is ready" : "Your new look is ready";

    input.setAttribute("placeholder", "Email to reveal your result");
    renderPreUnlockHostCard(preUnlockState, title, set);
    removePreUnlockFloatingElements();
    return true;
  }

  function renderLoadingExperience() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;

    var logo = findBrandLogo(widget);
    var existing = widget.querySelector("#basedai-loading-upgrade");
    var buttons = Array.prototype.slice.call(widget.querySelectorAll("button"));
    var isInteractiveStep = buttons.some(function (button) {
      return /^(TAKE SELFIE|UPLOAD SELFIE(?:\s*→)?|UPLOAD FROM LIBRARY|CONTINUE|UNLOCK YOUR LOOK NOW|LOGIN TO UNLOCK|TRY ANOTHER STYLE)$/i.test(normalizeText(button));
    });
    if (!logo || isInteractiveStep) {
      if (existing) existing.remove();
      stopLoadingPhraseRotation();
      return;
    }

    var label = readPendingLabel();
    var set = pickSetRecommendation(label);
    if (
      existing &&
      !existing.classList.contains("basedai-loading-upgrade--error") &&
      existing.getAttribute("data-result-label") === label &&
      existing.getAttribute("data-set-id") === set.id
    ) {
      startLoadingPhraseRotation(existing);
      return;
    }
    if (existing) existing.remove();

    var loadingPanel = document.createElement("section");
    loadingPanel.id = "basedai-loading-upgrade";
    loadingPanel.className = "basedai-loading-upgrade";
    loadingPanel.setAttribute("data-result-label", label);
    loadingPanel.setAttribute("data-set-id", set.id);
    loadingPanel.innerHTML =
      '<div class="basedai-loading-upgrade__phrase-wrap">' +
      '<span class="basedai-loading-upgrade__phrase" id="basedai-loading-phrase"></span>' +
      '</div>' +
      '<p class="basedai-loading-upgrade__sms">While you wait, text <strong>BASED</strong> to <strong>42420</strong> for special offers.</p>' +
      '<p class="basedai-loading-upgrade__sms-disclosure">*By texting BASED to 42420, you agree to receive recurring auto-dialed marketing SMS (including cart reminders; AI content; artificial or prerecorded voices) and our <a href="' +
      MESSAGING_TERMS_URL +
      '" target="_blank" rel="noreferrer">Terms of Service</a> (including arbitration). Consent is not required to purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help; STOP to opt out. View <a href="' +
      MESSAGING_PRIVACY_URL +
      '" target="_blank" rel="noreferrer">Privacy Policy</a>.</p>';

    var container = logo.parentElement;
    if (container) {
      var progress = logo.nextElementSibling;
      if (progress && progress.parentNode === container) {
        insertAfter(progress, loadingPanel);
      } else {
        insertAfter(logo, loadingPanel);
      }
    }
    startLoadingPhraseRotation(loadingPanel);
  }

  // Terminal errors hide the bar; automatic recovery restores it through clearGenerationError.
  function setLoadingProgressHidden(widget, hidden) {
    var logo = findBrandLogo(widget);
    var progress = logo && logo.nextElementSibling;
    if (!logo || !progress || progress.parentNode !== logo.parentElement) return;
    progress.hidden = hidden;
    if (hidden) {
      progress.setAttribute("aria-hidden", "true");
    } else {
      progress.removeAttribute("aria-hidden");
    }
  }

  function renderGenerationErrorExperience() {
    var error = readGenerationError();
    if (!error) return;

    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;

      var panel = widget.querySelector("#basedai-loading-upgrade");
      if (!panel) {
        var logo = findBrandLogo(widget);
        if (!logo) return;
      var container = logo.parentElement;
      var progress = logo.nextElementSibling;
      panel = document.createElement("section");
      panel.id = "basedai-loading-upgrade";
      panel.className = "basedai-loading-upgrade";
      if (container && progress && progress.parentNode === container) {
        insertAfter(progress, panel);
      } else if (container) {
        container.appendChild(panel);
      } else {
        return;
      }
    }

    var retryText = retryAfterText(error.retryAfterSeconds);
      var isRateLimited = Number(error.status) === 429;
      var isCapacityBusy = error.code === "generation_capacity_busy";
      var title = isCapacityBusy
        ? "High demand right now"
        : isRateLimited
          ? "Too many tries right now"
          : "Generation did not finish";
      var body = isCapacityBusy
        ? "Hair IQ is at its current generation limit." + (retryText ? " Try again in " + retryText + "." : " Please try again shortly.")
        : isRateLimited
          ? "This browser has made too many requests." + (retryText ? " Try again in " + retryText + "." : "")
          : String(error.message || "Something went wrong while creating this hairstyle.");
      stopLoadingPhraseRotation();
      setLoadingProgressHidden(widget, true);
      panel.classList.add("basedai-loading-upgrade--error");
    panel.innerHTML =
      '<p class="basedai-loading-upgrade__eyebrow">Generation paused</p>' +
      '<h2 class="basedai-loading-upgrade__title">' + escapeHtml(title) + '</h2>' +
      '<p class="basedai-loading-upgrade__body">' + escapeHtml(body) + '</p>' +
      '<button class="basedai-generation-error__button" type="button">Restart and try again</button>' +
      '<p class="basedai-generation-error__note">Your browser may keep the previous loading view until the page is restarted.</p>';

    var button = panel.querySelector("button");
    if (button) {
      button.addEventListener("click", function () {
        clearGenerationError();
        window.location.reload();
      });
    }
  }

  function buildShopAttributionPayload(set, label, destinationUrl) {
    var contentSlug = slug(label || (set && set.id) || "recommended-set");
    return sanitizeAnalyticsPayload({
      attribution_source: "hair_iq",
      attribution_medium: "app",
      attribution_campaign: "result_set_recommendation",
      attribution_content: contentSlug,
      utm_source: "ai_hairstyler",
      utm_medium: "app",
      utm_campaign: "result_set_recommendation",
      utm_content: contentSlug,
      set_id: set.id,
      set_name: set.name,
      product_id: set.id,
      product_name: set.name,
      recommendation_type: "set",
      destination_url: destinationUrl || set.url || null,
      result_label: label || null,
      hair_type: readSelectedTypeId(label),
      style_id: readStorageValue("basedai_styleId") || null,
      style_label: readStorageValue("basedai_styleLabel") || null,
      type_id: readStorageValue("basedai_typeId") || null,
      type_label: readStorageValue("basedai_typeLabel") || null,
      color_id: readStorageValue("basedai_colorId") || null,
      color_label: readStorageValue("basedai_colorLabel") || null
    });
  }

  function trackShopClick(set, label, destinationUrl) {
    var payload = buildShopAttributionPayload(set, label, destinationUrl);
    writeHairIqAttribution(payload);
    pushAnalyticsEvent("basedai_shop_click", payload);
  }

  function trackResultViewed(set, label) {
    pushAnalyticsEvent("basedai_result_viewed", {
      set_id: set.id,
      set_name: set.name,
      recommendation_type: "set",
      result_label: label || null,
      hair_type: readSelectedTypeId(label)
    }, {
      onceKey: "result_viewed:" + set.id + ":" + (label || "")
    });
  }

  function trackTryAnotherClick(label) {
    pushAnalyticsEvent("basedai_try_another_click", {
      control_text: "TRY ANOTHER STYLE",
      result_label: label || null,
      hair_type: readSelectedTypeId(label)
    });
  }

  function trackReturnHomeClick(label) {
    pushAnalyticsEvent("basedai_return_home_click", {
      control_text: "Return to Home",
      destination_url: "https://based.com/",
      result_label: label || null,
      hair_type: readSelectedTypeId(label)
    });
  }

  function trackGenerationRestartClick() {
    var label = readPendingLabel() || readResultLabel();
    pushAnalyticsEvent("basedai_generation_restart_click", {
      control_text: "Restart and try again",
      restart_source: "generation_error",
      result_label: label || null,
      hair_type: readSelectedTypeId(label)
    });
  }

  function ensureReturnHomeLink(widget, anchor) {
    if (!widget) return;
    var existing = widget.querySelector("#basedai-return-home");
    if (!anchor || !anchor.parentNode) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement("a");
      existing.id = "basedai-return-home";
      existing.className = "basedai-return-home";
      existing.href = "https://based.com/";
      existing.textContent = "Return to Home";
    }
    if (existing.parentNode !== anchor.parentNode || existing.previousElementSibling !== anchor) {
      insertAfter(anchor, existing);
    }
  }

  function ensureResultSaveNote(widget, anchor) {
    if (!widget) return null;
    var existing = widget.querySelector("#basedai-result-save-note");
    if (!anchor || !anchor.parentNode) {
      if (existing) existing.remove();
      return null;
    }
    if (!existing) {
      existing = document.createElement("p");
      existing.id = "basedai-result-save-note";
      existing.className = "basedai-result-save-note";
      existing.setAttribute("aria-atomic", "true");
      existing.innerHTML = "<strong>Save your look before you shop.</strong> Your result may not be available after you leave this page.";
    }
    if (existing.parentNode !== anchor.parentNode || existing.previousElementSibling !== anchor) {
      insertAfter(anchor, existing);
    }
    return existing;
  }

  function findResultImage(widget) {
    if (!widget || !widget.querySelector) return null;
    return widget.querySelector(
      'img[alt="Your tailored hairstyle"], img[data-uw-rm-alt-original="Your tailored hairstyle"]'
    );
  }

  function setResultSaveStatus(widget, headline, body) {
    var note = widget && widget.querySelector ? widget.querySelector("#basedai-result-save-note") : null;
    if (!note) return null;
    note.textContent = "";
    var strong = document.createElement("strong");
    strong.textContent = headline;
    note.appendChild(strong);
    if (body) note.appendChild(document.createTextNode(" " + body));
    note.setAttribute("role", "status");
    note.setAttribute("aria-live", "polite");
    return note;
  }

  function showManualResultSaveLink(widget, resultUrl) {
    var note = setResultSaveStatus(widget, "Sharing could not start.", "");
    if (!note) return;
    var link = document.createElement("a");
    link.href = resultUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "Open your result";
    note.appendChild(document.createTextNode(" "));
    note.appendChild(link);
    note.appendChild(document.createTextNode(", then press and hold the image to save it."));
  }

  function downloadResultBlob(blob) {
    if (!window.URL || typeof window.URL.createObjectURL !== "function") {
      throw new Error("Object URL downloads are unavailable");
    }
    var objectUrl = window.URL.createObjectURL(blob);
    var anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = RESULT_SHARE_FILE_NAME;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(objectUrl);
    }, 1000);
  }

  function saveOrShareResult(widget) {
    var image = findResultImage(widget);
    var resultUrl = image && (image.currentSrc || image.src || image.getAttribute("src"));
    if (!resultUrl) {
      setResultSaveStatus(widget, "Your result is not ready to save.", "Please wait a moment and try again.");
      return Promise.resolve("missing_result");
    }

    return Promise.resolve()
      .then(function () {
        if (typeof window.fetch !== "function") {
          throw new Error("Result image requests are unavailable");
        }
        return window.fetch(resultUrl);
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Result image request failed with HTTP " + response.status);
        }
        return response.blob();
      })
      .then(function (blob) {
        var file = null;
        try {
          if (typeof window.File === "function") {
            file = new window.File([blob], RESULT_SHARE_FILE_NAME, { type: blob.type || "image/png" });
          }
        } catch (_) {
          file = null;
        }

        var canShareFile = false;
        if (file && window.navigator && typeof window.navigator.share === "function" && typeof window.navigator.canShare === "function") {
          try {
            canShareFile = !!window.navigator.canShare({ files: [file] });
          } catch (_) {
            canShareFile = false;
          }
        }

        if (canShareFile) {
          return Promise.resolve()
            .then(function () {
              return window.navigator.share({
                title: "My Hair IQ Hairstyle",
                text: RESULT_SHARE_TEXT,
                files: [file]
              });
            })
            .then(function () {
              return "shared";
            })
            .catch(function (error) {
              if (error && error.name === "AbortError") return "cancelled";
              console.warn("Hair IQ share failed; downloading instead", error);
              downloadResultBlob(blob);
              setResultSaveStatus(widget, "Your download is starting.", "Keep the file before leaving this page.");
              return "downloaded";
            });
        }

        downloadResultBlob(blob);
        setResultSaveStatus(widget, "Your download is starting.", "Keep the file before leaving this page.");
        return "downloaded";
      })
      .catch(function (error) {
        console.warn("Hair IQ result could not be prepared for sharing", error);
        showManualResultSaveLink(widget, resultUrl);
        return "manual_save";
      });
  }

  function ensureResultShareHandler(widget, shareButton) {
    if (!widget || !shareButton || shareButton.getAttribute("data-basedai-share-handler") === "true") return;
    shareButton.setAttribute("data-basedai-share-handler", "true");
    shareButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
        if (shareButton.getAttribute("data-basedai-share-busy") === "true") return;
        shareButton.setAttribute("data-basedai-share-busy", "true");
        shareButton.setAttribute("aria-busy", "true");
        saveOrShareResult(widget).then(
          function () {
            shareButton.removeAttribute("data-basedai-share-busy");
            shareButton.removeAttribute("aria-busy");
          },
          function () {
            shareButton.removeAttribute("data-basedai-share-busy");
            shareButton.removeAttribute("aria-busy");
          }
        );
      },
      true
    );
  }

  function renderResultOffer() {
    var widget = document.querySelector(".basedai-widget");
    if (!widget) return;

    var buttons = Array.prototype.slice.call(widget.querySelectorAll("button"));
    var tryAnother = buttons.find(function (button) {
      return /^TRY ANOTHER STYLE$/i.test(normalizeText(button));
    });
    var existing = widget.querySelector("#basedai-result-offer");
    var saveNote = widget.querySelector("#basedai-result-save-note");
    var returnHome = widget.querySelector("#basedai-return-home");
    if (!tryAnother) {
      if (existing) existing.remove();
      if (saveNote) saveNote.remove();
      if (returnHome) returnHome.remove();
      Array.prototype.slice.call(widget.querySelectorAll(".basedai-result-scroll-shell")).forEach(function (node) {
        node.classList.remove("basedai-result-scroll-shell");
      });
      Array.prototype.slice.call(widget.querySelectorAll(".basedai-result-action-block")).forEach(function (node) {
        node.classList.remove("basedai-result-action-block");
      });
      return;
    }

    var actionBlock = tryAnother.parentElement && tryAnother.parentElement.parentElement;
    if (actionBlock && actionBlock.classList) {
      actionBlock.classList.add("basedai-result-action-block");
    }
    var shareButton = tryAnother.parentElement && Array.prototype.slice.call(tryAnother.parentElement.querySelectorAll("button")).find(function (button) {
      return button !== tryAnother;
    });
    if (shareButton) {
      shareButton.setAttribute("aria-label", "Save or share your Hair IQ result");
      shareButton.setAttribute("title", "Save or share");
    }
    var resultShell = actionBlock && actionBlock.parentElement;
    if (resultShell && resultShell.classList) {
      resultShell.classList.add("basedai-result-scroll-shell");
    }
    saveNote = ensureResultSaveNote(widget, actionBlock);
    ensureResultShareHandler(widget, shareButton);

    var label = readResultLabel();
    var set = pickSetRecommendation(label);
    trackResultViewed(set, label);
    if (existing && existing.getAttribute("data-set-id") === set.id && existing.getAttribute("data-result-label") === label) {
      if (saveNote && existing.previousElementSibling !== saveNote) {
        insertAfter(saveNote, existing);
      }
      ensureReturnHomeLink(widget, existing);
      return;
    }
    if (existing) existing.remove();

    var contentSlug = slug(label || set.id);
    var setUrl = withUtm(set.url, {
      utm_source: "ai_hairstyler",
      utm_medium: "app",
      utm_campaign: "result_set_recommendation",
      utm_content: contentSlug
    });
    var offer = document.createElement("details");
    offer.id = "basedai-result-offer";
    offer.className = "basedai-result-offer";
    offer.setAttribute("data-set-id", set.id);
    offer.setAttribute("data-result-label", label);
    offer.innerHTML =
      '<summary class="basedai-result-offer__summary">Want to achieve this hairstyle?<span class="basedai-result-offer__chevron" aria-hidden="true"></span></summary>' +
      '<div class="basedai-result-offer__box">' +
      '<img class="basedai-result-offer__image" src="' + assetPath(set.image) + '" alt="' + escapeHtml(set.name) + ' bundle">' +
      '<div class="basedai-result-offer__copy">' +
      '<p class="basedai-result-offer__eyebrow">' + escapeHtml(set.eyebrow) + '</p>' +
      '<h2 class="basedai-result-offer__title">' + escapeHtml(set.name) + '</h2>' +
      '<p class="basedai-result-offer__body">' + escapeHtml(set.line) + '</p>' +
      '<p class="basedai-result-offer__contains">Includes: ' + escapeHtml(set.contains || "A focused styling routine for this hair type") + '</p>' +
      '</div>' +
      '<div class="basedai-result-offer__actions">' +
      '<a class="basedai-result-offer__button basedai-result-offer__button--primary" href="' + setUrl + '">View set</a>' +
      '</div>' +
      '</div>';

    Array.prototype.slice.call(offer.querySelectorAll("a")).forEach(function (link) {
      link.addEventListener("click", function () {
        trackShopClick(set, label, link.href);
      });
    });

    var offerAnchor = saveNote || actionBlock;
    if (offerAnchor && offerAnchor.parentNode) {
      insertAfter(offerAnchor, offer);
    } else {
      widget.appendChild(offer);
    }
    ensureReturnHomeLink(widget, offer);
  }

  function installInlineConsentDisclosures() {
    if (window.__BasedAIPrivacyInlineDisclosureInstalled) return;
    window.__BasedAIPrivacyInlineDisclosureInstalled = true;
    ensureDisclosureStyles();
    installActionConsentListeners();

    var pending = false;
    function scheduleRender() {
      if (pending) return;
      pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          replaceBranding();
          replaceStylePickerAssets();
          renderInlineConsentNotes();
          renderLoadingExperience();
          renderGenerationErrorExperience();
          var hasPreUnlock = renderPreUnlockExperience();
          renderResultOffer();
          syncManagedLayoutState();
          if (hasPreUnlock) {
            schedulePreUnlockRepair();
          } else {
            clearPreUnlockRepairTimers();
          }
      });
    }

    scheduleRender();
    new MutationObserver(scheduleRender).observe(document.documentElement, {
      childList: true,
      attributes: true,
      attributeFilter: ["alt", "aria-disabled", "class", "data-uw-rm-alt", "data-uw-rm-alt-original", "disabled", "role", "src", "style"],
      subtree: true
    });
  }

  function loadWidget() {
    if (widgetLoaded) return;
    widgetLoaded = true;
    var tag = document.createElement("script");
    tag.type = "module";
    tag.src = assetPath(widgetAssetName + "?cb=" + encodeURIComponent(widgetAssetVersion));
    document.body.appendChild(tag);
  }

  function removeGate() {
    var gate = document.getElementById("basedai-privacy-gate");
    if (gate) gate.remove();
    var root = document.getElementById("root") || document.getElementById("find-your-hairstyle-root");
    if (root) root.hidden = false;
  }

  installEphemeralStorageShim();
  installConsentFetchShim();
  installCameraConsentShim();
  installWidgetAssetResolver();

  window.BasedAIPrivacy = {
    getConsent: readConsent,
    grantPhotoConsent: grantPhotoConsent,
    grantEmailConsent: grantEmailConsent,
    clear: function () {
      window.sessionStorage.removeItem(CONSENT_KEY);
      PRIVATE_KEYS.forEach(function (key) {
        window.sessionStorage.removeItem(key);
      });
      clearPersistentWidgetState();
    },
    getDiagnostics: function () {
      return (window[DIAGNOSTICS_KEY] || []).slice();
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    removeGate();
    loadWidget();
    installInlineConsentDisclosures();
  });
})();
